//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IApiClient {
    /**
     * Creates a new appointment disposition update request
     * @return OK
     */
    createAppointmentDispositionUpdateRequest(body: CreateAppointmentDispositionUpdateRequestDto): Observable<void>;
    /**
     * Creates a new appointment disposition update submission
     * @return OK
     */
    createAppointmentDispositionUpdateSubmission(body: CreateAppointmentDispositionUpdateSubmissionDto): Observable<PendingSaleAppointmentDispositionInfo>;
    /**
     * Updates the disposition of a service appointment
     * @return Created
     */
    updateServiceAppointmentDispositionSubmission(body: UpdateServiceAppointmentDispositionSubmissionDto): Observable<UpdateServiceAppointmentDispositionSubmissionDto>;
    /**
     * Get calendar by day for user
     * @return OK
     */
    getCalendarByDayForUser(email: string, date: Date): Observable<CalendarByDayInfo[]>;
    /**
     * Retrieves appointments missing dispositions for a given inspector email
     * @return OK
     */
    getMissingDispositions(inspectorEmail: string): Observable<MissingDispositionInfo[]>;
    /**
     * Get appointment action buttons for an opportunity
     * @return OK
     */
    getAppointmentActions(opportunityId: string): Observable<ActionRefLink[]>;
    /**
     * Retrieves all appointment dispositions and sub-dispositions
     * @return OK
     */
    getAppointmentDispositions(): Observable<AppointmentDispositionItemInfo[]>;
    /**
     * Retrieves all appointment dispositions and sub-dispositions
     * @return OK
     */
    getAppointmentDispositionsWeb(): Observable<AppointmentDispositionItemInfo[]>;
    /**
     * Create a new appointment sales touchpoint
     * @return OK
     */
    createAppointmentSalesTouchpoint(userEmail: string, body: CreateAppointmentSalesTouchpointRequest): Observable<SalesTouchpointInfo>;
    /**
     * Retrieves appointments sales touchpoints for a given appointmentId
     * @return OK
     */
    getAppointmentSalesTouchpointEndpoints(appointmentId: string): Observable<SalesTouchpointInfo[]>;
    /**
     * Retrieves all attachment groups
     * @return OK
     */
    getAttachmentGroups(): Observable<AttachmentGroupInfo[]>;
    /**
     * Retrieves all attachment groups with Bearer authorization
     * @return OK
     */
    getAttachmentGroupsWeb(): Observable<AttachmentGroupInfo[]>;
    /**
     * Get attachments by opportunity ID
     * @return OK
     */
    getAttachments(opportunityId: string): Observable<AttachmentInfo[]>;
    /**
     * Upload a single file to Azure Blob Storage
     * @param file (optional) 
     * @param quoteId (optional) 
     * @param attachmentGroupId (optional) 
     * @param description (optional) 
     * @return OK
     */
    uploadAttachment(opportunityId: string, appointmentId: string, file: FileParameter | undefined, quoteId: string | null | undefined, attachmentGroupId: string | null | undefined, description: string | null | undefined): Observable<AzureBlobUploadResult[]>;
    /**
     * Delete an attachment
     * @return OK
     */
    deleteAttachment(attachmentId: string): Observable<void>;
    /**
     * Update an attachment in the sales app
     * @return OK
     */
    updateAttachmentInSalesApp(attachmentId: string, body: UpdateAttachmentRequestData): Observable<void>;
    /**
     * Retrieves all branches
     * @return OK
     */
    listBranches(): Observable<BranchInfo[]>;
    /**
     * Retrieves a list of branches for the current user in GSS
     * @return OK
     */
    getBranchesForCurrentUser(): Observable<UserBranchesInfo>;
    /**
     * Get all opportunities for a customer
     * @return OK
     */
    getCustomerOpportunities(customerId: number): Observable<CustomerOpportunitiesInfo>;
    /**
     * Send a deposit request (Authvia SMS) for an opportunity
     * @return OK
     */
    sendDeposit(body: SendDepositRequest): Observable<SendDepositResult>;
    /**
     * Upload a single file to Azure Blob Storage
     * @return OK
     */
    uploadSingleFile(opportunityId: string, appointmentId: string, inspectorEmail: string): Observable<AzureBlobUploadResult[]>;
    /**
     * Get attachments by opportunity ID
     * @return OK
     */
    getAttachmentsByOpportunityId(opportunityId: string): Observable<AttachmentInfo[]>;
    /**
     * Update an attachment record
     * @return OK
     */
    updateAttachment(attachmentId: string, inspectorEmail: string, body: UpdateAttachmentRequestData): Observable<UpdateAttachmentResult>;
    /**
     * Upload a file from a remote URL
     * @return OK
     */
    uploadRemoteFile(body: UploadRemoteFileRequest): Observable<void>;
    /**
     * Get calendar by day for the authenticated user in GSS
     * @return OK
     */
    getCalendarByDayForUser_v2(date: Date): Observable<CalendarByDayInfo[]>;
    /**
     * Get an opportunity by ID
     * @return OK
     */
    getOpportunity(id: string): Observable<OpportunityInfo>;
    /**
     * Deactivate an opportunity
     * @return OK
     */
    deactivateOpportunity(id: string, body: DeactivateOpportunityRequest): Observable<OpportunityInfo>;
    /**
     * Retrieves all attachment groups
     * @return OK
     */
    getAttachmentGroupsV2(): Observable<AttachmentGroupInfo[]>;
    /**
     * Retrieves appointments missing dispositions for a given inspector email
     * @return OK
     */
    getMissingDispositions_v2(inspectorEmail: string): Observable<MissingDispositionInfo[]>;
    /**
     * Creates a new appointment disposition update request
     * @return OK
     */
    createAppointmentDispositionUpdateRequest_v2(body: CreateAppointmentDispositionUpdateRequestDto): Observable<void>;
    /**
     * Retrieves all appointment dispositions and sub-dispositions
     * @return OK
     */
    getAppointmentDispositions_v2(): Observable<AppointmentDispositionItemInfo[]>;
    /**
     * Create a new appointment sales touchpoint
     * @return OK
     */
    createAppointmentSalesTouchpoint_v2(userEmail: string, body: CreateAppointmentSalesTouchpointRequest): Observable<SalesTouchpointInfo>;
    /**
     * Retrieves appointments sales touchpoints for a given appointmentId
     * @return OK
     */
    getAppointmentSalesTouchpointEndpoints_v2(appointmentId: string): Observable<SalesTouchpointInfo[]>;
    /**
     * Upload a single file to Azure Blob Storage
     * @return OK
     */
    uploadSingleFileV2(opportunityId: string, appointmentId: string, inspectorEmail: string): Observable<AzureBlobUploadResult[]>;
    /**
     * Get attachments by opportunity ID
     * @return OK
     */
    getAttachmentsByOpportunityIdV2(opportunityId: string): Observable<AttachmentInfo[]>;
    /**
     * Update an attachment record
     * @return OK
     */
    updateAttachmentV2(attachmentId: string, inspectorEmail: string, body: UpdateAttachmentRequestData): Observable<UpdateAttachmentResult>;
    /**
     * Upload a file from a remote URL
     * @return OK
     */
    uploadRemoteFileV2(body: UploadRemoteFileRequest): Observable<void>;
    /**
     * Sync Quote into the sales application from GSS
     * @return OK
     */
    syncQuote_v2(body: SyncQuoteRequest): Observable<string>;
    /**
     * Sync a service-appointment quote into the sales application from GSS
     * @return OK
     */
    syncServiceQuote_v2(body: SyncServiceQuoteRequest): Observable<string>;
    /**
     * Queue a self-generated quote for processing
     * @return Accepted
     */
    saveSelfGenQuote_v2(body: SyncQuoteRequest): Observable<void>;
    /**
     * Retrieves all attachment groups (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getAttachmentGroupsV3(x_requesting_user_id: string | undefined): Observable<AttachmentGroupInfo[]>;
    /**
     * Retrieves attachment groups by group type (v3 external for the Mobile BFF)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getExternalAttachmentGroupsByTypeV3(groupType: string, x_requesting_user_id: string | undefined): Observable<AttachmentGroupInfo[]>;
    /**
     * Retrieves appointment dispositions and sub-dispositions, optionally filtered by category (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @param category (optional) 
     * @return OK
     */
    getAppointmentDispositionsV3(x_requesting_user_id: string | undefined, category: string | undefined): Observable<AppointmentDispositionItemInfo[]>;
    /**
     * Retrieves service dispositions (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getServiceDispositionsV3(x_requesting_user_id: string | undefined): Observable<ServiceDispositionItemInfo[]>;
    /**
     * Records a service appointment disposition (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return Created
     */
    createServiceAppointmentDispositionV3(appointmentId: string, x_requesting_user_id: string | undefined, body: CreateServiceAppointmentDispositionRequestV3Dto): Observable<ServiceAppointmentDispositionInfo>;
    /**
     * Records an appointment disposition (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return Created
     */
    createAppointmentDispositionUpdateRequestV3(appointmentId: string, x_requesting_user_id: string | undefined, body: CreateAppointmentDispositionUpdateRequestV3Dto): Observable<PendingSaleAppointmentDispositionInfo>;
    /**
     * Retrieves the requesting inspector's appointments missing a disposition (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getMissingDispositionsV3(x_requesting_user_id: string | undefined): Observable<MissingDispositionInfoV3[]>;
    /**
     * Create an appointment sales touchpoint (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    createAppointmentSalesTouchpointV3(x_requesting_user_id: string | undefined, body: CreateAppointmentSalesTouchpointV3Dto): Observable<SalesTouchpointInfo>;
    /**
     * Retrieves sales touchpoints for an appointment (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getAppointmentSalesTouchpointsV3(appointmentId: string, x_requesting_user_id: string | undefined): Observable<SalesTouchpointInfo[]>;
    /**
     * Create an opportunity sales touchpoint (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    createOpportunitySalesTouchpointV3(opportunityId: string, x_requesting_user_id: string | undefined, body: CreateOpportunitySalesTouchpointV3Dto): Observable<SalesTouchpointInfo>;
    /**
     * Retrieves sales touchpoints for an opportunity (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getOpportunitySalesTouchpointsV3(opportunityId: string, x_requesting_user_id: string | undefined): Observable<SalesTouchpointInfo[]>;
    /**
     * Get attachments by opportunity ID (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getAttachmentsByOpportunityIdV3(opportunityId: string, x_requesting_user_id: string | undefined): Observable<AttachmentInfo[]>;
    /**
     * Update an attachment record (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    updateAttachmentV3(attachmentId: string, x_requesting_user_id: string | undefined, body: UpdateAttachmentRequestData): Observable<void>;
    /**
     * Upload a single file to Azure Blob Storage (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    uploadSingleFileV3(opportunityId: string, appointmentId: string, x_requesting_user_id: string | undefined): Observable<SingleFileUploadResult[]>;
    /**
     * Upload a file from a remote URL (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    uploadRemoteFileV3(x_requesting_user_id: string | undefined, body: UploadRemoteFileRequest): Observable<void>;
    /**
     * Retrieves the requesting user's sales + service appointments missing a disposition (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getUnifiedMissingDispositionsV3(x_requesting_user_id: string | undefined): Observable<UnifiedMissingDispositionInfo[]>;
    /**
     * Get selectable manual payment methods
     * @return OK
     */
    getManualPaymentMethods(): Observable<PaymentMethodInfo[]>;
    /**
     * Record a manual payment for an opportunity
     * @return OK
     */
    recordManualPayment(body: RecordManualPaymentRequest): Observable<PaymentInfo>;
    /**
     * Get an opportunity's payment summary
     * @return OK
     */
    getPaymentSummary(opportunityId: string): Observable<PaymentSummary>;
    /**
     * Get all pending sales
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getPendingSales(branchIds: string[], startDate: Date | undefined, endDate: Date | undefined): Observable<PendingSalesListboxInfo>;
    /**
     * Add virtual appointment for quote generation
     * @return OK
     */
    generateQuote(body: QuoteRequest): Observable<AppointmentInfo>;
    /**
     * Update quote sale approval checklist items
     * @return OK
     */
    updateQuote(id: string, body: UpdateQuoteRequest): Observable<QuoteInfo>;
    /**
     * Get all quotes for branches
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getQuotes(branchIds: string[], startDate: Date | undefined, endDate: Date | undefined): Observable<QuotesListboxInfo>;
    /**
     * Sync Quote into the sales application from GSS
     * @return OK
     */
    syncQuote(body: SyncQuoteRequest): Observable<string>;
    /**
     * Queue a self-generated quote for processing
     * @return Accepted
     */
    saveSelfGenQuote(body: SyncQuoteRequest): Observable<void>;
    /**
     * Get condensed quotes for an opportunity
     * @return OK
     */
    getCondensedQuotesByOpportunityId(opportunityId: string): Observable<CondensedQuotes>;
    /**
     * Create a new sale
     * @return OK
     */
    createSale(body: CreateSaleRequest): Observable<SaleInfo>;
    /**
     * Find quotes without sales on sold appointments and create sales for them
     * @return OK
     */
    approveSales(): Observable<AutomatedSaleApprovalResult>;
    /**
     * Approve pending sales for a specific branch
     * @return OK
     */
    approveSalesByBranch(branchId: string): Observable<AutomatedSaleApprovalResult>;
    /**
     * Get all branches for sales automation
     * @return OK
     */
    getAutomationBranches(): Observable<BranchInfo[]>;
    /**
     * Get all unreviewed sales
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getUnreviewedSales(branchIds: string[], startDate: Date | undefined, endDate: Date | undefined): Observable<UnreviewedSalesListboxInfo>;
    /**
     * Create a new sales touchpoint
     * @return Created
     */
    createSalesTouchpoint(body: CreateSalesTouchpointRequest): Observable<SalesTouchpointInfo>;
    /**
     * Get all sales touchpoints for an opportunity
     * @return OK
     */
    getSalesTouchpoints(opportunityId: string): Observable<SalesTouchpointInfo[]>;
    /**
     * Retrieves all service appointment dispositions
     * @return OK
     */
    getServiceDispositions(): Observable<ServiceDispositionItemInfo[]>;
    /**
     * Retrieves all service appointment dispositions
     * @return OK
     */
    getServiceDispositionsWeb(): Observable<ServiceDispositionItemInfo[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ApiClient implements IApiClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a new appointment disposition update request
     * @return OK
     */
    createAppointmentDispositionUpdateRequest(body: CreateAppointmentDispositionUpdateRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/v1/appointment/disposition-update-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAppointmentDispositionUpdateRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAppointmentDispositionUpdateRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateAppointmentDispositionUpdateRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new appointment disposition update submission
     * @return OK
     */
    createAppointmentDispositionUpdateSubmission(body: CreateAppointmentDispositionUpdateSubmissionDto): Observable<PendingSaleAppointmentDispositionInfo> {
        let url_ = this.baseUrl + "/v1/appointment/disposition-update-submission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAppointmentDispositionUpdateSubmission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAppointmentDispositionUpdateSubmission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingSaleAppointmentDispositionInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingSaleAppointmentDispositionInfo>;
        }));
    }

    protected processCreateAppointmentDispositionUpdateSubmission(response: HttpResponseBase): Observable<PendingSaleAppointmentDispositionInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendingSaleAppointmentDispositionInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PendingSaleAppointmentDispositionInfo.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the disposition of a service appointment
     * @return Created
     */
    updateServiceAppointmentDispositionSubmission(body: UpdateServiceAppointmentDispositionSubmissionDto): Observable<UpdateServiceAppointmentDispositionSubmissionDto> {
        let url_ = this.baseUrl + "/v1/appointment/service-disposition-update-submission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateServiceAppointmentDispositionSubmission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateServiceAppointmentDispositionSubmission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateServiceAppointmentDispositionSubmissionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateServiceAppointmentDispositionSubmissionDto>;
        }));
    }

    protected processUpdateServiceAppointmentDispositionSubmission(response: HttpResponseBase): Observable<UpdateServiceAppointmentDispositionSubmissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = UpdateServiceAppointmentDispositionSubmissionDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get calendar by day for user
     * @return OK
     */
    getCalendarByDayForUser(email: string, date: Date): Observable<CalendarByDayInfo[]> {
        let url_ = this.baseUrl + "/v1/appointment/calendar?";
        if (email === undefined || email === null)
            throw new globalThis.Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarByDayForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarByDayForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarByDayInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarByDayInfo[]>;
        }));
    }

    protected processGetCalendarByDayForUser(response: HttpResponseBase): Observable<CalendarByDayInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarByDayInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves appointments missing dispositions for a given inspector email
     * @return OK
     */
    getMissingDispositions(inspectorEmail: string): Observable<MissingDispositionInfo[]> {
        let url_ = this.baseUrl + "/v1/appointment/missing-dispositions/{inspectorEmail}";
        if (inspectorEmail === undefined || inspectorEmail === null)
            throw new globalThis.Error("The parameter 'inspectorEmail' must be defined.");
        url_ = url_.replace("{inspectorEmail}", encodeURIComponent("" + inspectorEmail));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMissingDispositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissingDispositions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MissingDispositionInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MissingDispositionInfo[]>;
        }));
    }

    protected processGetMissingDispositions(response: HttpResponseBase): Observable<MissingDispositionInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MissingDispositionInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get appointment action buttons for an opportunity
     * @return OK
     */
    getAppointmentActions(opportunityId: string): Observable<ActionRefLink[]> {
        let url_ = this.baseUrl + "/v1/appointment/actions/opportunityId/{opportunityId}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentActions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActionRefLink[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActionRefLink[]>;
        }));
    }

    protected processGetAppointmentActions(response: HttpResponseBase): Observable<ActionRefLink[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActionRefLink.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all appointment dispositions and sub-dispositions
     * @return OK
     */
    getAppointmentDispositions(): Observable<AppointmentDispositionItemInfo[]> {
        let url_ = this.baseUrl + "/v1/appointment-disposition";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentDispositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentDispositions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppointmentDispositionItemInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppointmentDispositionItemInfo[]>;
        }));
    }

    protected processGetAppointmentDispositions(response: HttpResponseBase): Observable<AppointmentDispositionItemInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentDispositionItemInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all appointment dispositions and sub-dispositions
     * @return OK
     */
    getAppointmentDispositionsWeb(): Observable<AppointmentDispositionItemInfo[]> {
        let url_ = this.baseUrl + "/v1/appointment-disposition/web";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentDispositionsWeb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentDispositionsWeb(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppointmentDispositionItemInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppointmentDispositionItemInfo[]>;
        }));
    }

    protected processGetAppointmentDispositionsWeb(response: HttpResponseBase): Observable<AppointmentDispositionItemInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentDispositionItemInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new appointment sales touchpoint
     * @return OK
     */
    createAppointmentSalesTouchpoint(userEmail: string, body: CreateAppointmentSalesTouchpointRequest): Observable<SalesTouchpointInfo> {
        let url_ = this.baseUrl + "/v1/appointment-sales-touchpoint/{userEmail}";
        if (userEmail === undefined || userEmail === null)
            throw new globalThis.Error("The parameter 'userEmail' must be defined.");
        url_ = url_.replace("{userEmail}", encodeURIComponent("" + userEmail));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAppointmentSalesTouchpoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAppointmentSalesTouchpoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesTouchpointInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesTouchpointInfo>;
        }));
    }

    protected processCreateAppointmentSalesTouchpoint(response: HttpResponseBase): Observable<SalesTouchpointInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesTouchpointInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves appointments sales touchpoints for a given appointmentId
     * @return OK
     */
    getAppointmentSalesTouchpointEndpoints(appointmentId: string): Observable<SalesTouchpointInfo[]> {
        let url_ = this.baseUrl + "/v1/appointment-sales-touchpoint/{appointmentId}";
        if (appointmentId === undefined || appointmentId === null)
            throw new globalThis.Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentSalesTouchpointEndpoints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentSalesTouchpointEndpoints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesTouchpointInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesTouchpointInfo[]>;
        }));
    }

    protected processGetAppointmentSalesTouchpointEndpoints(response: HttpResponseBase): Observable<SalesTouchpointInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesTouchpointInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all attachment groups
     * @return OK
     */
    getAttachmentGroups(): Observable<AttachmentGroupInfo[]> {
        let url_ = this.baseUrl + "/v1/attachment-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentGroupInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentGroupInfo[]>;
        }));
    }

    protected processGetAttachmentGroups(response: HttpResponseBase): Observable<AttachmentGroupInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentGroupInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all attachment groups with Bearer authorization
     * @return OK
     */
    getAttachmentGroupsWeb(): Observable<AttachmentGroupInfo[]> {
        let url_ = this.baseUrl + "/v1/attachment-groups/web";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentGroupsWeb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentGroupsWeb(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentGroupInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentGroupInfo[]>;
        }));
    }

    protected processGetAttachmentGroupsWeb(response: HttpResponseBase): Observable<AttachmentGroupInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentGroupInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get attachments by opportunity ID
     * @return OK
     */
    getAttachments(opportunityId: string): Observable<AttachmentInfo[]> {
        let url_ = this.baseUrl + "/v1/attachments/opportunity/{opportunityId}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentInfo[]>;
        }));
    }

    protected processGetAttachments(response: HttpResponseBase): Observable<AttachmentInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload a single file to Azure Blob Storage
     * @param file (optional) 
     * @param quoteId (optional) 
     * @param attachmentGroupId (optional) 
     * @param description (optional) 
     * @return OK
     */
    uploadAttachment(opportunityId: string, appointmentId: string, file: FileParameter | undefined, quoteId: string | null | undefined, attachmentGroupId: string | null | undefined, description: string | null | undefined): Observable<AzureBlobUploadResult[]> {
        let url_ = this.baseUrl + "/v1/attachments/upload/opportunity/{opportunityId}/appointment/{appointmentId}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        if (appointmentId === undefined || appointmentId === null)
            throw new globalThis.Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (quoteId !== null && quoteId !== undefined)
            content_.append("quoteId", quoteId.toString());
        if (attachmentGroupId !== null && attachmentGroupId !== undefined)
            content_.append("attachmentGroupId", attachmentGroupId.toString());
        if (description !== null && description !== undefined)
            content_.append("description", description.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AzureBlobUploadResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AzureBlobUploadResult[]>;
        }));
    }

    protected processUploadAttachment(response: HttpResponseBase): Observable<AzureBlobUploadResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AzureBlobUploadResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete an attachment
     * @return OK
     */
    deleteAttachment(attachmentId: string): Observable<void> {
        let url_ = this.baseUrl + "/v1/attachments/{attachmentId}";
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an attachment in the sales app
     * @return OK
     */
    updateAttachmentInSalesApp(attachmentId: string, body: UpdateAttachmentRequestData): Observable<void> {
        let url_ = this.baseUrl + "/v1/attachments/{attachmentId}";
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAttachmentInSalesApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAttachmentInSalesApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAttachmentInSalesApp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all branches
     * @return OK
     */
    listBranches(): Observable<BranchInfo[]> {
        let url_ = this.baseUrl + "/v1/branches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListBranches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchInfo[]>;
        }));
    }

    protected processListBranches(response: HttpResponseBase): Observable<BranchInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of branches for the current user in GSS
     * @return OK
     */
    getBranchesForCurrentUser(): Observable<UserBranchesInfo> {
        let url_ = this.baseUrl + "/v1/branches/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchesForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchesForCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserBranchesInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserBranchesInfo>;
        }));
    }

    protected processGetBranchesForCurrentUser(response: HttpResponseBase): Observable<UserBranchesInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserBranchesInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all opportunities for a customer
     * @return OK
     */
    getCustomerOpportunities(customerId: number): Observable<CustomerOpportunitiesInfo> {
        let url_ = this.baseUrl + "/v1/customer/{customerId}/opportunities";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerOpportunities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerOpportunities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerOpportunitiesInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerOpportunitiesInfo>;
        }));
    }

    protected processGetCustomerOpportunities(response: HttpResponseBase): Observable<CustomerOpportunitiesInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerOpportunitiesInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send a deposit request (Authvia SMS) for an opportunity
     * @return OK
     */
    sendDeposit(body: SendDepositRequest): Observable<SendDepositResult> {
        let url_ = this.baseUrl + "/v1/deposits/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDeposit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDeposit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendDepositResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendDepositResult>;
        }));
    }

    protected processSendDeposit(response: HttpResponseBase): Observable<SendDepositResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendDepositResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result502: any = null;
            let resultData502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload a single file to Azure Blob Storage
     * @return OK
     */
    uploadSingleFile(opportunityId: string, appointmentId: string, inspectorEmail: string): Observable<AzureBlobUploadResult[]> {
        let url_ = this.baseUrl + "/v1/files/external/upload/single/{opportunityId}/{appointmentId}/{inspectorEmail}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        if (appointmentId === undefined || appointmentId === null)
            throw new globalThis.Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        if (inspectorEmail === undefined || inspectorEmail === null)
            throw new globalThis.Error("The parameter 'inspectorEmail' must be defined.");
        url_ = url_.replace("{inspectorEmail}", encodeURIComponent("" + inspectorEmail));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSingleFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSingleFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AzureBlobUploadResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AzureBlobUploadResult[]>;
        }));
    }

    protected processUploadSingleFile(response: HttpResponseBase): Observable<AzureBlobUploadResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AzureBlobUploadResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get attachments by opportunity ID
     * @return OK
     */
    getAttachmentsByOpportunityId(opportunityId: string): Observable<AttachmentInfo[]> {
        let url_ = this.baseUrl + "/v1/files/external/opportunity/{opportunityId}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentsByOpportunityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentsByOpportunityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentInfo[]>;
        }));
    }

    protected processGetAttachmentsByOpportunityId(response: HttpResponseBase): Observable<AttachmentInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an attachment record
     * @return OK
     */
    updateAttachment(attachmentId: string, inspectorEmail: string, body: UpdateAttachmentRequestData): Observable<UpdateAttachmentResult> {
        let url_ = this.baseUrl + "/v1/files/external/attachment-update/{attachmentId}/{inspectorEmail}";
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        if (inspectorEmail === undefined || inspectorEmail === null)
            throw new globalThis.Error("The parameter 'inspectorEmail' must be defined.");
        url_ = url_.replace("{inspectorEmail}", encodeURIComponent("" + inspectorEmail));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateAttachmentResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateAttachmentResult>;
        }));
    }

    protected processUpdateAttachment(response: HttpResponseBase): Observable<UpdateAttachmentResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAttachmentResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload a file from a remote URL
     * @return OK
     */
    uploadRemoteFile(body: UploadRemoteFileRequest): Observable<void> {
        let url_ = this.baseUrl + "/v1/files/external/upload/remote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadRemoteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadRemoteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadRemoteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get calendar by day for the authenticated user in GSS
     * @return OK
     */
    getCalendarByDayForUser_v2(date: Date): Observable<CalendarByDayInfo[]> {
        let url_ = this.baseUrl + "/v2/appointment/calendar?";
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarByDayForUser_v2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarByDayForUser_v2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalendarByDayInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalendarByDayInfo[]>;
        }));
    }

    protected processGetCalendarByDayForUser_v2(response: HttpResponseBase): Observable<CalendarByDayInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarByDayInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get an opportunity by ID
     * @return OK
     */
    getOpportunity(id: string): Observable<OpportunityInfo> {
        let url_ = this.baseUrl + "/v1/opportunity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpportunity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpportunity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityInfo>;
        }));
    }

    protected processGetOpportunity(response: HttpResponseBase): Observable<OpportunityInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OpportunityInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deactivate an opportunity
     * @return OK
     */
    deactivateOpportunity(id: string, body: DeactivateOpportunityRequest): Observable<OpportunityInfo> {
        let url_ = this.baseUrl + "/v1/opportunity/{id}/deactivate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateOpportunity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateOpportunity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityInfo>;
        }));
    }

    protected processDeactivateOpportunity(response: HttpResponseBase): Observable<OpportunityInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OpportunityInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all attachment groups
     * @return OK
     */
    getAttachmentGroupsV2(): Observable<AttachmentGroupInfo[]> {
        let url_ = this.baseUrl + "/v2/attachment-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentGroupsV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentGroupsV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentGroupInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentGroupInfo[]>;
        }));
    }

    protected processGetAttachmentGroupsV2(response: HttpResponseBase): Observable<AttachmentGroupInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentGroupInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves appointments missing dispositions for a given inspector email
     * @return OK
     */
    getMissingDispositions_v2(inspectorEmail: string): Observable<MissingDispositionInfo[]> {
        let url_ = this.baseUrl + "/v2/appointment/missing-dispositions/{inspectorEmail}";
        if (inspectorEmail === undefined || inspectorEmail === null)
            throw new globalThis.Error("The parameter 'inspectorEmail' must be defined.");
        url_ = url_.replace("{inspectorEmail}", encodeURIComponent("" + inspectorEmail));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMissingDispositions_v2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissingDispositions_v2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MissingDispositionInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MissingDispositionInfo[]>;
        }));
    }

    protected processGetMissingDispositions_v2(response: HttpResponseBase): Observable<MissingDispositionInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MissingDispositionInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new appointment disposition update request
     * @return OK
     */
    createAppointmentDispositionUpdateRequest_v2(body: CreateAppointmentDispositionUpdateRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/v2/appointment/disposition-update-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAppointmentDispositionUpdateRequest_v2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAppointmentDispositionUpdateRequest_v2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateAppointmentDispositionUpdateRequest_v2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all appointment dispositions and sub-dispositions
     * @return OK
     */
    getAppointmentDispositions_v2(): Observable<AppointmentDispositionItemInfo[]> {
        let url_ = this.baseUrl + "/v2/appointment-disposition";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentDispositions_v2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentDispositions_v2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppointmentDispositionItemInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppointmentDispositionItemInfo[]>;
        }));
    }

    protected processGetAppointmentDispositions_v2(response: HttpResponseBase): Observable<AppointmentDispositionItemInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentDispositionItemInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new appointment sales touchpoint
     * @return OK
     */
    createAppointmentSalesTouchpoint_v2(userEmail: string, body: CreateAppointmentSalesTouchpointRequest): Observable<SalesTouchpointInfo> {
        let url_ = this.baseUrl + "/v2/appointment-sales-touchpoint/{userEmail}";
        if (userEmail === undefined || userEmail === null)
            throw new globalThis.Error("The parameter 'userEmail' must be defined.");
        url_ = url_.replace("{userEmail}", encodeURIComponent("" + userEmail));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAppointmentSalesTouchpoint_v2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAppointmentSalesTouchpoint_v2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesTouchpointInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesTouchpointInfo>;
        }));
    }

    protected processCreateAppointmentSalesTouchpoint_v2(response: HttpResponseBase): Observable<SalesTouchpointInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesTouchpointInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves appointments sales touchpoints for a given appointmentId
     * @return OK
     */
    getAppointmentSalesTouchpointEndpoints_v2(appointmentId: string): Observable<SalesTouchpointInfo[]> {
        let url_ = this.baseUrl + "/v2/appointment-sales-touchpoint/{appointmentId}";
        if (appointmentId === undefined || appointmentId === null)
            throw new globalThis.Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentSalesTouchpointEndpoints_v2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentSalesTouchpointEndpoints_v2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesTouchpointInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesTouchpointInfo[]>;
        }));
    }

    protected processGetAppointmentSalesTouchpointEndpoints_v2(response: HttpResponseBase): Observable<SalesTouchpointInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesTouchpointInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload a single file to Azure Blob Storage
     * @return OK
     */
    uploadSingleFileV2(opportunityId: string, appointmentId: string, inspectorEmail: string): Observable<AzureBlobUploadResult[]> {
        let url_ = this.baseUrl + "/v2/files/external/upload/single/{opportunityId}/{appointmentId}/{inspectorEmail}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        if (appointmentId === undefined || appointmentId === null)
            throw new globalThis.Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        if (inspectorEmail === undefined || inspectorEmail === null)
            throw new globalThis.Error("The parameter 'inspectorEmail' must be defined.");
        url_ = url_.replace("{inspectorEmail}", encodeURIComponent("" + inspectorEmail));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSingleFileV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSingleFileV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AzureBlobUploadResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AzureBlobUploadResult[]>;
        }));
    }

    protected processUploadSingleFileV2(response: HttpResponseBase): Observable<AzureBlobUploadResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AzureBlobUploadResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get attachments by opportunity ID
     * @return OK
     */
    getAttachmentsByOpportunityIdV2(opportunityId: string): Observable<AttachmentInfo[]> {
        let url_ = this.baseUrl + "/v2/files/external/opportunity/{opportunityId}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentsByOpportunityIdV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentsByOpportunityIdV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentInfo[]>;
        }));
    }

    protected processGetAttachmentsByOpportunityIdV2(response: HttpResponseBase): Observable<AttachmentInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an attachment record
     * @return OK
     */
    updateAttachmentV2(attachmentId: string, inspectorEmail: string, body: UpdateAttachmentRequestData): Observable<UpdateAttachmentResult> {
        let url_ = this.baseUrl + "/v2/files/external/attachment-update/{attachmentId}/{inspectorEmail}";
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        if (inspectorEmail === undefined || inspectorEmail === null)
            throw new globalThis.Error("The parameter 'inspectorEmail' must be defined.");
        url_ = url_.replace("{inspectorEmail}", encodeURIComponent("" + inspectorEmail));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAttachmentV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAttachmentV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateAttachmentResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateAttachmentResult>;
        }));
    }

    protected processUpdateAttachmentV2(response: HttpResponseBase): Observable<UpdateAttachmentResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAttachmentResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload a file from a remote URL
     * @return OK
     */
    uploadRemoteFileV2(body: UploadRemoteFileRequest): Observable<void> {
        let url_ = this.baseUrl + "/v2/files/external/upload/remote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadRemoteFileV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadRemoteFileV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadRemoteFileV2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sync Quote into the sales application from GSS
     * @return OK
     */
    syncQuote_v2(body: SyncQuoteRequest): Observable<string> {
        let url_ = this.baseUrl + "/v2/quote/sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncQuote_v2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncQuote_v2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSyncQuote_v2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sync a service-appointment quote into the sales application from GSS
     * @return OK
     */
    syncServiceQuote_v2(body: SyncServiceQuoteRequest): Observable<string> {
        let url_ = this.baseUrl + "/v2/quote/service-sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncServiceQuote_v2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncServiceQuote_v2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSyncServiceQuote_v2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Queue a self-generated quote for processing
     * @return Accepted
     */
    saveSelfGenQuote_v2(body: SyncQuoteRequest): Observable<void> {
        let url_ = this.baseUrl + "/v2/quote/self-gen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSelfGenQuote_v2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSelfGenQuote_v2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveSelfGenQuote_v2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all attachment groups (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getAttachmentGroupsV3(x_requesting_user_id: string | undefined): Observable<AttachmentGroupInfo[]> {
        let url_ = this.baseUrl + "/v3/attachment-groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentGroupsV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentGroupsV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentGroupInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentGroupInfo[]>;
        }));
    }

    protected processGetAttachmentGroupsV3(response: HttpResponseBase): Observable<AttachmentGroupInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentGroupInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves attachment groups by group type (v3 external for the Mobile BFF)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getExternalAttachmentGroupsByTypeV3(groupType: string, x_requesting_user_id: string | undefined): Observable<AttachmentGroupInfo[]> {
        let url_ = this.baseUrl + "/v3/external/attachments/groups/{groupType}";
        if (groupType === undefined || groupType === null)
            throw new globalThis.Error("The parameter 'groupType' must be defined.");
        url_ = url_.replace("{groupType}", encodeURIComponent("" + groupType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAttachmentGroupsByTypeV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAttachmentGroupsByTypeV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentGroupInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentGroupInfo[]>;
        }));
    }

    protected processGetExternalAttachmentGroupsByTypeV3(response: HttpResponseBase): Observable<AttachmentGroupInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentGroupInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves appointment dispositions and sub-dispositions, optionally filtered by category (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @param category (optional) 
     * @return OK
     */
    getAppointmentDispositionsV3(x_requesting_user_id: string | undefined, category: string | undefined): Observable<AppointmentDispositionItemInfo[]> {
        let url_ = this.baseUrl + "/v3/appointment-dispositions?";
        if (category === null)
            throw new globalThis.Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentDispositionsV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentDispositionsV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppointmentDispositionItemInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppointmentDispositionItemInfo[]>;
        }));
    }

    protected processGetAppointmentDispositionsV3(response: HttpResponseBase): Observable<AppointmentDispositionItemInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppointmentDispositionItemInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves service dispositions (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getServiceDispositionsV3(x_requesting_user_id: string | undefined): Observable<ServiceDispositionItemInfo[]> {
        let url_ = this.baseUrl + "/v3/service/dispositions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceDispositionsV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceDispositionsV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDispositionItemInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDispositionItemInfo[]>;
        }));
    }

    protected processGetServiceDispositionsV3(response: HttpResponseBase): Observable<ServiceDispositionItemInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceDispositionItemInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Records a service appointment disposition (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return Created
     */
    createServiceAppointmentDispositionV3(appointmentId: string, x_requesting_user_id: string | undefined, body: CreateServiceAppointmentDispositionRequestV3Dto): Observable<ServiceAppointmentDispositionInfo> {
        let url_ = this.baseUrl + "/v3/service-appointments/{appointmentId}/disposition";
        if (appointmentId === undefined || appointmentId === null)
            throw new globalThis.Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateServiceAppointmentDispositionV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateServiceAppointmentDispositionV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceAppointmentDispositionInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceAppointmentDispositionInfo>;
        }));
    }

    protected processCreateServiceAppointmentDispositionV3(response: HttpResponseBase): Observable<ServiceAppointmentDispositionInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ServiceAppointmentDispositionInfo.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Records an appointment disposition (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return Created
     */
    createAppointmentDispositionUpdateRequestV3(appointmentId: string, x_requesting_user_id: string | undefined, body: CreateAppointmentDispositionUpdateRequestV3Dto): Observable<PendingSaleAppointmentDispositionInfo> {
        let url_ = this.baseUrl + "/v3/appointments/{appointmentId}/disposition";
        if (appointmentId === undefined || appointmentId === null)
            throw new globalThis.Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAppointmentDispositionUpdateRequestV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAppointmentDispositionUpdateRequestV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingSaleAppointmentDispositionInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingSaleAppointmentDispositionInfo>;
        }));
    }

    protected processCreateAppointmentDispositionUpdateRequestV3(response: HttpResponseBase): Observable<PendingSaleAppointmentDispositionInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PendingSaleAppointmentDispositionInfo.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the requesting inspector's appointments missing a disposition (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getMissingDispositionsV3(x_requesting_user_id: string | undefined): Observable<MissingDispositionInfoV3[]> {
        let url_ = this.baseUrl + "/v3/appointments/missing-dispositions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMissingDispositionsV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissingDispositionsV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MissingDispositionInfoV3[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MissingDispositionInfoV3[]>;
        }));
    }

    protected processGetMissingDispositionsV3(response: HttpResponseBase): Observable<MissingDispositionInfoV3[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MissingDispositionInfoV3.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create an appointment sales touchpoint (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    createAppointmentSalesTouchpointV3(x_requesting_user_id: string | undefined, body: CreateAppointmentSalesTouchpointV3Dto): Observable<SalesTouchpointInfo> {
        let url_ = this.baseUrl + "/v3/appointment-sales-touchpoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAppointmentSalesTouchpointV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAppointmentSalesTouchpointV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesTouchpointInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesTouchpointInfo>;
        }));
    }

    protected processCreateAppointmentSalesTouchpointV3(response: HttpResponseBase): Observable<SalesTouchpointInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesTouchpointInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves sales touchpoints for an appointment (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getAppointmentSalesTouchpointsV3(appointmentId: string, x_requesting_user_id: string | undefined): Observable<SalesTouchpointInfo[]> {
        let url_ = this.baseUrl + "/v3/appointment-sales-touchpoint/{appointmentId}";
        if (appointmentId === undefined || appointmentId === null)
            throw new globalThis.Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppointmentSalesTouchpointsV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppointmentSalesTouchpointsV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesTouchpointInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesTouchpointInfo[]>;
        }));
    }

    protected processGetAppointmentSalesTouchpointsV3(response: HttpResponseBase): Observable<SalesTouchpointInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesTouchpointInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create an opportunity sales touchpoint (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    createOpportunitySalesTouchpointV3(opportunityId: string, x_requesting_user_id: string | undefined, body: CreateOpportunitySalesTouchpointV3Dto): Observable<SalesTouchpointInfo> {
        let url_ = this.baseUrl + "/v3/opportunity/{opportunityId}/sales-touchpoints";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOpportunitySalesTouchpointV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOpportunitySalesTouchpointV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesTouchpointInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesTouchpointInfo>;
        }));
    }

    protected processCreateOpportunitySalesTouchpointV3(response: HttpResponseBase): Observable<SalesTouchpointInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesTouchpointInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves sales touchpoints for an opportunity (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getOpportunitySalesTouchpointsV3(opportunityId: string, x_requesting_user_id: string | undefined): Observable<SalesTouchpointInfo[]> {
        let url_ = this.baseUrl + "/v3/opportunity/{opportunityId}/sales-touchpoints";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpportunitySalesTouchpointsV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpportunitySalesTouchpointsV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesTouchpointInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesTouchpointInfo[]>;
        }));
    }

    protected processGetOpportunitySalesTouchpointsV3(response: HttpResponseBase): Observable<SalesTouchpointInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesTouchpointInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get attachments by opportunity ID (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getAttachmentsByOpportunityIdV3(opportunityId: string, x_requesting_user_id: string | undefined): Observable<AttachmentInfo[]> {
        let url_ = this.baseUrl + "/v3/files/external/opportunity/{opportunityId}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentsByOpportunityIdV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentsByOpportunityIdV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentInfo[]>;
        }));
    }

    protected processGetAttachmentsByOpportunityIdV3(response: HttpResponseBase): Observable<AttachmentInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an attachment record (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    updateAttachmentV3(attachmentId: string, x_requesting_user_id: string | undefined, body: UpdateAttachmentRequestData): Observable<void> {
        let url_ = this.baseUrl + "/v3/files/external/attachment-update/{attachmentId}";
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAttachmentV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAttachmentV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAttachmentV3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload a single file to Azure Blob Storage (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    uploadSingleFileV3(opportunityId: string, appointmentId: string, x_requesting_user_id: string | undefined): Observable<SingleFileUploadResult[]> {
        let url_ = this.baseUrl + "/v3/files/external/upload/single/{opportunityId}/{appointmentId}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        if (appointmentId === undefined || appointmentId === null)
            throw new globalThis.Error("The parameter 'appointmentId' must be defined.");
        url_ = url_.replace("{appointmentId}", encodeURIComponent("" + appointmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSingleFileV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSingleFileV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SingleFileUploadResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SingleFileUploadResult[]>;
        }));
    }

    protected processUploadSingleFileV3(response: HttpResponseBase): Observable<SingleFileUploadResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SingleFileUploadResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload a file from a remote URL (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    uploadRemoteFileV3(x_requesting_user_id: string | undefined, body: UploadRemoteFileRequest): Observable<void> {
        let url_ = this.baseUrl + "/v3/files/external/upload/remote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadRemoteFileV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadRemoteFileV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadRemoteFileV3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the requesting user's sales + service appointments missing a disposition (v3 for Mobile.API)
     * @param x_requesting_user_id (optional) 
     * @return OK
     */
    getUnifiedMissingDispositionsV3(x_requesting_user_id: string | undefined): Observable<UnifiedMissingDispositionInfo[]> {
        let url_ = this.baseUrl + "/v3/missing-dispositions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "x-requesting-user-id": x_requesting_user_id !== undefined && x_requesting_user_id !== null ? "" + x_requesting_user_id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnifiedMissingDispositionsV3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnifiedMissingDispositionsV3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnifiedMissingDispositionInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnifiedMissingDispositionInfo[]>;
        }));
    }

    protected processGetUnifiedMissingDispositionsV3(response: HttpResponseBase): Observable<UnifiedMissingDispositionInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnifiedMissingDispositionInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get selectable manual payment methods
     * @return OK
     */
    getManualPaymentMethods(): Observable<PaymentMethodInfo[]> {
        let url_ = this.baseUrl + "/v1/payments/methods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualPaymentMethods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualPaymentMethods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentMethodInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentMethodInfo[]>;
        }));
    }

    protected processGetManualPaymentMethods(response: HttpResponseBase): Observable<PaymentMethodInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentMethodInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Record a manual payment for an opportunity
     * @return OK
     */
    recordManualPayment(body: RecordManualPaymentRequest): Observable<PaymentInfo> {
        let url_ = this.baseUrl + "/v1/payments/manual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecordManualPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecordManualPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentInfo>;
        }));
    }

    protected processRecordManualPayment(response: HttpResponseBase): Observable<PaymentInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);
            }));
        } else if (status === 502) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result502: any = null;
            let resultData502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result502 = ProblemDetails.fromJS(resultData502);
            return throwException("Bad Gateway", status, _responseText, _headers, result502);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get an opportunity's payment summary
     * @return OK
     */
    getPaymentSummary(opportunityId: string): Observable<PaymentSummary> {
        let url_ = this.baseUrl + "/v1/payments/summary/{opportunityId}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentSummary>;
        }));
    }

    protected processGetPaymentSummary(response: HttpResponseBase): Observable<PaymentSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all pending sales
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getPendingSales(branchIds: string[], startDate: Date | undefined, endDate: Date | undefined): Observable<PendingSalesListboxInfo> {
        let url_ = this.baseUrl + "/v1/pending-sales?";
        if (branchIds === undefined || branchIds === null)
            throw new globalThis.Error("The parameter 'branchIds' must be defined and cannot be null.");
        else
            branchIds && branchIds.forEach(item => { url_ += "branchIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingSalesListboxInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingSalesListboxInfo>;
        }));
    }

    protected processGetPendingSales(response: HttpResponseBase): Observable<PendingSalesListboxInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendingSalesListboxInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add virtual appointment for quote generation
     * @return OK
     */
    generateQuote(body: QuoteRequest): Observable<AppointmentInfo> {
        let url_ = this.baseUrl + "/v1/quote/generate-new-quote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppointmentInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppointmentInfo>;
        }));
    }

    protected processGenerateQuote(response: HttpResponseBase): Observable<AppointmentInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update quote sale approval checklist items
     * @return OK
     */
    updateQuote(id: string, body: UpdateQuoteRequest): Observable<QuoteInfo> {
        let url_ = this.baseUrl + "/v1/quote/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteInfo>;
        }));
    }

    protected processUpdateQuote(response: HttpResponseBase): Observable<QuoteInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all quotes for branches
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getQuotes(branchIds: string[], startDate: Date | undefined, endDate: Date | undefined): Observable<QuotesListboxInfo> {
        let url_ = this.baseUrl + "/v1/quote/quotes?";
        if (branchIds === undefined || branchIds === null)
            throw new globalThis.Error("The parameter 'branchIds' must be defined and cannot be null.");
        else
            branchIds && branchIds.forEach(item => { url_ += "branchIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotesListboxInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotesListboxInfo>;
        }));
    }

    protected processGetQuotes(response: HttpResponseBase): Observable<QuotesListboxInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuotesListboxInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sync Quote into the sales application from GSS
     * @return OK
     */
    syncQuote(body: SyncQuoteRequest): Observable<string> {
        let url_ = this.baseUrl + "/v1/quote/sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSyncQuote(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Queue a self-generated quote for processing
     * @return Accepted
     */
    saveSelfGenQuote(body: SyncQuoteRequest): Observable<void> {
        let url_ = this.baseUrl + "/v1/quote/self-gen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSelfGenQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSelfGenQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveSelfGenQuote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get condensed quotes for an opportunity
     * @return OK
     */
    getCondensedQuotesByOpportunityId(opportunityId: string): Observable<CondensedQuotes> {
        let url_ = this.baseUrl + "/v1/quote/condensed/opportunityId/{opportunityId}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCondensedQuotesByOpportunityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCondensedQuotesByOpportunityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CondensedQuotes>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CondensedQuotes>;
        }));
    }

    protected processGetCondensedQuotesByOpportunityId(response: HttpResponseBase): Observable<CondensedQuotes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CondensedQuotes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new sale
     * @return OK
     */
    createSale(body: CreateSaleRequest): Observable<SaleInfo> {
        let url_ = this.baseUrl + "/v1/sales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaleInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaleInfo>;
        }));
    }

    protected processCreateSale(response: HttpResponseBase): Observable<SaleInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaleInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Find quotes without sales on sold appointments and create sales for them
     * @return OK
     */
    approveSales(): Observable<AutomatedSaleApprovalResult> {
        let url_ = this.baseUrl + "/v1/sales/automation/approve";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutomatedSaleApprovalResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutomatedSaleApprovalResult>;
        }));
    }

    protected processApproveSales(response: HttpResponseBase): Observable<AutomatedSaleApprovalResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutomatedSaleApprovalResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Approve pending sales for a specific branch
     * @return OK
     */
    approveSalesByBranch(branchId: string): Observable<AutomatedSaleApprovalResult> {
        let url_ = this.baseUrl + "/v1/sales/automation/approve/{branchId}";
        if (branchId === undefined || branchId === null)
            throw new globalThis.Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveSalesByBranch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveSalesByBranch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutomatedSaleApprovalResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutomatedSaleApprovalResult>;
        }));
    }

    protected processApproveSalesByBranch(response: HttpResponseBase): Observable<AutomatedSaleApprovalResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutomatedSaleApprovalResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all branches for sales automation
     * @return OK
     */
    getAutomationBranches(): Observable<BranchInfo[]> {
        let url_ = this.baseUrl + "/v1/sales/automation/branches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutomationBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutomationBranches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BranchInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BranchInfo[]>;
        }));
    }

    protected processGetAutomationBranches(response: HttpResponseBase): Observable<BranchInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all unreviewed sales
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getUnreviewedSales(branchIds: string[], startDate: Date | undefined, endDate: Date | undefined): Observable<UnreviewedSalesListboxInfo> {
        let url_ = this.baseUrl + "/v1/sales/unreviewed?";
        if (branchIds === undefined || branchIds === null)
            throw new globalThis.Error("The parameter 'branchIds' must be defined and cannot be null.");
        else
            branchIds && branchIds.forEach(item => { url_ += "branchIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnreviewedSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnreviewedSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnreviewedSalesListboxInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnreviewedSalesListboxInfo>;
        }));
    }

    protected processGetUnreviewedSales(response: HttpResponseBase): Observable<UnreviewedSalesListboxInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnreviewedSalesListboxInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new sales touchpoint
     * @return Created
     */
    createSalesTouchpoint(body: CreateSalesTouchpointRequest): Observable<SalesTouchpointInfo> {
        let url_ = this.baseUrl + "/v1/sales-touchpoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSalesTouchpoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSalesTouchpoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesTouchpointInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesTouchpointInfo>;
        }));
    }

    protected processCreateSalesTouchpoint(response: HttpResponseBase): Observable<SalesTouchpointInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = SalesTouchpointInfo.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all sales touchpoints for an opportunity
     * @return OK
     */
    getSalesTouchpoints(opportunityId: string): Observable<SalesTouchpointInfo[]> {
        let url_ = this.baseUrl + "/v1/sales-touchpoint/{opportunityId}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesTouchpoints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesTouchpoints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesTouchpointInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesTouchpointInfo[]>;
        }));
    }

    protected processGetSalesTouchpoints(response: HttpResponseBase): Observable<SalesTouchpointInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesTouchpointInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all service appointment dispositions
     * @return OK
     */
    getServiceDispositions(): Observable<ServiceDispositionItemInfo[]> {
        let url_ = this.baseUrl + "/v1/service-disposition";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceDispositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceDispositions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDispositionItemInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDispositionItemInfo[]>;
        }));
    }

    protected processGetServiceDispositions(response: HttpResponseBase): Observable<ServiceDispositionItemInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceDispositionItemInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all service appointment dispositions
     * @return OK
     */
    getServiceDispositionsWeb(): Observable<ServiceDispositionItemInfo[]> {
        let url_ = this.baseUrl + "/v1/service-disposition/web";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceDispositionsWeb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceDispositionsWeb(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDispositionItemInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDispositionItemInfo[]>;
        }));
    }

    protected processGetServiceDispositionsWeb(response: HttpResponseBase): Observable<ServiceDispositionItemInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceDispositionItemInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ActionRefLink implements IActionRefLink {
    href!: string | undefined;
    name!: string | undefined;
    variant!: string | undefined;
    isDisabled!: boolean;

    constructor(data?: IActionRefLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.href = _data["href"];
            this.name = _data["name"];
            this.variant = _data["variant"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): ActionRefLink {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRefLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["href"] = this.href;
        data["name"] = this.name;
        data["variant"] = this.variant;
        data["isDisabled"] = this.isDisabled;
        return data;
    }
}

export interface IActionRefLink {
    href: string | undefined;
    name: string | undefined;
    variant: string | undefined;
    isDisabled: boolean;
}

export class AddressInfo implements IAddressInfo {
    id?: string;
    streetAddress!: string | undefined;
    streetAddress2?: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    postalCode!: string | undefined;
    isCommercial!: boolean;
    createdAt!: Date;
    createdBy?: string | undefined;
    companyName?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IAddressInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.streetAddress = _data["streetAddress"];
            this.streetAddress2 = _data["streetAddress2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.isCommercial = _data["isCommercial"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.companyName = _data["companyName"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): AddressInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AddressInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["streetAddress"] = this.streetAddress;
        data["streetAddress2"] = this.streetAddress2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["isCommercial"] = this.isCommercial;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["companyName"] = this.companyName;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IAddressInfo {
    id?: string;
    streetAddress: string | undefined;
    streetAddress2?: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postalCode: string | undefined;
    isCommercial: boolean;
    createdAt: Date;
    createdBy?: string | undefined;
    companyName?: string | undefined;
    isDeleted?: boolean;
}

export class AppointmentAddressInfo implements IAppointmentAddressInfo {
    id!: string;
    streetAddress!: string | undefined;
    streetAddress2?: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    postalCode!: string | undefined;

    constructor(data?: IAppointmentAddressInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.streetAddress = _data["streetAddress"];
            this.streetAddress2 = _data["streetAddress2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): AppointmentAddressInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentAddressInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["streetAddress"] = this.streetAddress;
        data["streetAddress2"] = this.streetAddress2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IAppointmentAddressInfo {
    id: string;
    streetAddress: string | undefined;
    streetAddress2?: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postalCode: string | undefined;
}

export class AppointmentContactInfo implements IAppointmentContactInfo {
    id!: string;
    firstName!: string | undefined;
    lastName!: string | undefined;
    isCommercial!: boolean;
    email!: string | undefined;
    phone!: string | undefined;
    isPrimary!: boolean;
    createdAt!: Date;

    constructor(data?: IAppointmentContactInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isCommercial = _data["isCommercial"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.isPrimary = _data["isPrimary"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AppointmentContactInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentContactInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isCommercial"] = this.isCommercial;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["isPrimary"] = this.isPrimary;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IAppointmentContactInfo {
    id: string;
    firstName: string | undefined;
    lastName: string | undefined;
    isCommercial: boolean;
    email: string | undefined;
    phone: string | undefined;
    isPrimary: boolean;
    createdAt: Date;
}

export class AppointmentDispositionItemInfo implements IAppointmentDispositionItemInfo {
    id!: string;
    name!: string | undefined;
    category!: string | undefined;
    subDispositions!: AppointmentSubDispositionInfo[] | undefined;

    constructor(data?: IAppointmentDispositionItemInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.category = _data["category"];
            if (Array.isArray(_data["subDispositions"])) {
                this.subDispositions = [] as any;
                for (let item of _data["subDispositions"])
                    this.subDispositions!.push(AppointmentSubDispositionInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppointmentDispositionItemInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDispositionItemInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["category"] = this.category;
        if (Array.isArray(this.subDispositions)) {
            data["subDispositions"] = [];
            for (let item of this.subDispositions)
                data["subDispositions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAppointmentDispositionItemInfo {
    id: string;
    name: string | undefined;
    category: string | undefined;
    subDispositions: AppointmentSubDispositionInfo[] | undefined;
}

export class AppointmentGeozoneInfo implements IAppointmentGeozoneInfo {
    id!: string;
    name!: string | undefined;

    constructor(data?: IAppointmentGeozoneInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AppointmentGeozoneInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentGeozoneInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAppointmentGeozoneInfo {
    id: string;
    name: string | undefined;
}

export class AppointmentInfo implements IAppointmentInfo {
    id?: string;
    opportunityId?: string;
    startDate?: Date;
    endDate?: Date;
    appointmentTypeId?: string;
    leadTypeId?: string | undefined;
    legacyAppointmentId?: number | undefined;
    legacyGeoZoneId?: number | undefined;
    geoZoneId?: string | undefined;
    dispositionId?: string | undefined;
    subDispositionId?: string | undefined;
    dispositionEnteredAt?: Date | undefined;
    appointmentTypeName?: string | undefined;
    branchId?: string | undefined;
    inspectorName?: string | undefined;
    legacyUserId?: number | undefined;
    userId?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
    dispositionName?: string | undefined;
    subDispositionName?: string | undefined;
    isDeleted?: boolean;
    isCancelled?: boolean;
    isServiceRun?: boolean;

    constructor(data?: IAppointmentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.opportunityId = _data["opportunityId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.appointmentTypeId = _data["appointmentTypeId"];
            this.leadTypeId = _data["leadTypeId"];
            this.legacyAppointmentId = _data["legacyAppointmentId"];
            this.legacyGeoZoneId = _data["legacyGeoZoneId"];
            this.geoZoneId = _data["geoZoneId"];
            this.dispositionId = _data["dispositionId"];
            this.subDispositionId = _data["subDispositionId"];
            this.dispositionEnteredAt = _data["dispositionEnteredAt"] ? new Date(_data["dispositionEnteredAt"].toString()) : undefined as any;
            this.appointmentTypeName = _data["appointmentTypeName"];
            this.branchId = _data["branchId"];
            this.inspectorName = _data["inspectorName"];
            this.legacyUserId = _data["legacyUserId"];
            this.userId = _data["userId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.dispositionName = _data["dispositionName"];
            this.subDispositionName = _data["subDispositionName"];
            this.isDeleted = _data["isDeleted"];
            this.isCancelled = _data["isCancelled"];
            this.isServiceRun = _data["isServiceRun"];
        }
    }

    static fromJS(data: any): AppointmentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["opportunityId"] = this.opportunityId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["appointmentTypeId"] = this.appointmentTypeId;
        data["leadTypeId"] = this.leadTypeId;
        data["legacyAppointmentId"] = this.legacyAppointmentId;
        data["legacyGeoZoneId"] = this.legacyGeoZoneId;
        data["geoZoneId"] = this.geoZoneId;
        data["dispositionId"] = this.dispositionId;
        data["subDispositionId"] = this.subDispositionId;
        data["dispositionEnteredAt"] = this.dispositionEnteredAt ? this.dispositionEnteredAt.toISOString() : undefined as any;
        data["appointmentTypeName"] = this.appointmentTypeName;
        data["branchId"] = this.branchId;
        data["inspectorName"] = this.inspectorName;
        data["legacyUserId"] = this.legacyUserId;
        data["userId"] = this.userId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["dispositionName"] = this.dispositionName;
        data["subDispositionName"] = this.subDispositionName;
        data["isDeleted"] = this.isDeleted;
        data["isCancelled"] = this.isCancelled;
        data["isServiceRun"] = this.isServiceRun;
        return data;
    }
}

export interface IAppointmentInfo {
    id?: string;
    opportunityId?: string;
    startDate?: Date;
    endDate?: Date;
    appointmentTypeId?: string;
    leadTypeId?: string | undefined;
    legacyAppointmentId?: number | undefined;
    legacyGeoZoneId?: number | undefined;
    geoZoneId?: string | undefined;
    dispositionId?: string | undefined;
    subDispositionId?: string | undefined;
    dispositionEnteredAt?: Date | undefined;
    appointmentTypeName?: string | undefined;
    branchId?: string | undefined;
    inspectorName?: string | undefined;
    legacyUserId?: number | undefined;
    userId?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
    dispositionName?: string | undefined;
    subDispositionName?: string | undefined;
    isDeleted?: boolean;
    isCancelled?: boolean;
    isServiceRun?: boolean;
}

export class AppointmentSubDispositionInfo implements IAppointmentSubDispositionInfo {
    id!: string;
    name!: string | undefined;

    constructor(data?: IAppointmentSubDispositionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AppointmentSubDispositionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentSubDispositionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAppointmentSubDispositionInfo {
    id: string;
    name: string | undefined;
}

export class AttachmentGroupInfo implements IAttachmentGroupInfo {
    id!: string;
    name!: string | undefined;

    constructor(data?: IAttachmentGroupInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AttachmentGroupInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentGroupInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAttachmentGroupInfo {
    id: string;
    name: string | undefined;
}

export class AttachmentInfo implements IAttachmentInfo {
    id?: string | undefined;
    customerId?: number | undefined;
    opportunityId?: string | undefined;
    appointmentId?: string | undefined;
    serviceAppointmentId?: string | undefined;
    quoteId?: string | undefined;
    attachmentGroupId?: string | undefined;
    attachmentGroup?: string | undefined;
    fileName!: string | undefined;
    filePath!: string | undefined;
    fileNameOnServer!: string | undefined;
    description!: string | undefined;
    subFolderPath!: string | undefined;
    createdBy?: string | undefined;
    contentType?: string | undefined;
    attachmentContainerBranchId!: string;
    createdAt?: Date | undefined;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;

    constructor(data?: IAttachmentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.opportunityId = _data["opportunityId"];
            this.appointmentId = _data["appointmentId"];
            this.serviceAppointmentId = _data["serviceAppointmentId"];
            this.quoteId = _data["quoteId"];
            this.attachmentGroupId = _data["attachmentGroupId"];
            this.attachmentGroup = _data["attachmentGroup"];
            this.fileName = _data["fileName"];
            this.filePath = _data["filePath"];
            this.fileNameOnServer = _data["fileNameOnServer"];
            this.description = _data["description"];
            this.subFolderPath = _data["subFolderPath"];
            this.createdBy = _data["createdBy"];
            this.contentType = _data["contentType"];
            this.attachmentContainerBranchId = _data["attachmentContainerBranchId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AttachmentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["opportunityId"] = this.opportunityId;
        data["appointmentId"] = this.appointmentId;
        data["serviceAppointmentId"] = this.serviceAppointmentId;
        data["quoteId"] = this.quoteId;
        data["attachmentGroupId"] = this.attachmentGroupId;
        data["attachmentGroup"] = this.attachmentGroup;
        data["fileName"] = this.fileName;
        data["filePath"] = this.filePath;
        data["fileNameOnServer"] = this.fileNameOnServer;
        data["description"] = this.description;
        data["subFolderPath"] = this.subFolderPath;
        data["createdBy"] = this.createdBy;
        data["contentType"] = this.contentType;
        data["attachmentContainerBranchId"] = this.attachmentContainerBranchId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IAttachmentInfo {
    id?: string | undefined;
    customerId?: number | undefined;
    opportunityId?: string | undefined;
    appointmentId?: string | undefined;
    serviceAppointmentId?: string | undefined;
    quoteId?: string | undefined;
    attachmentGroupId?: string | undefined;
    attachmentGroup?: string | undefined;
    fileName: string | undefined;
    filePath: string | undefined;
    fileNameOnServer: string | undefined;
    description: string | undefined;
    subFolderPath: string | undefined;
    createdBy?: string | undefined;
    contentType?: string | undefined;
    attachmentContainerBranchId: string;
    createdAt?: Date | undefined;
    updatedBy?: string | undefined;
    updatedAt?: Date | undefined;
}

export class AutomatedSaleApprovalResult implements IAutomatedSaleApprovalResult {
    successes!: AutomatedSaleCreationSuccess[] | undefined;
    failures!: AutomatedSaleCreationFailure[] | undefined;

    constructor(data?: IAutomatedSaleApprovalResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["successes"])) {
                this.successes = [] as any;
                for (let item of _data["successes"])
                    this.successes!.push(AutomatedSaleCreationSuccess.fromJS(item));
            }
            if (Array.isArray(_data["failures"])) {
                this.failures = [] as any;
                for (let item of _data["failures"])
                    this.failures!.push(AutomatedSaleCreationFailure.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AutomatedSaleApprovalResult {
        data = typeof data === 'object' ? data : {};
        let result = new AutomatedSaleApprovalResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.successes)) {
            data["successes"] = [];
            for (let item of this.successes)
                data["successes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.failures)) {
            data["failures"] = [];
            for (let item of this.failures)
                data["failures"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAutomatedSaleApprovalResult {
    successes: AutomatedSaleCreationSuccess[] | undefined;
    failures: AutomatedSaleCreationFailure[] | undefined;
}

export class AutomatedSaleCreationFailure implements IAutomatedSaleCreationFailure {
    quoteId!: string;
    opportunityId!: string;
    error!: string | undefined;
    errorCode?: string | undefined;
    appointmentId?: string;
    serviceAppointmentId?: string | undefined;

    constructor(data?: IAutomatedSaleCreationFailure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data["quoteId"];
            this.opportunityId = _data["opportunityId"];
            this.error = _data["error"];
            this.errorCode = _data["errorCode"];
            this.appointmentId = _data["appointmentId"];
            this.serviceAppointmentId = _data["serviceAppointmentId"];
        }
    }

    static fromJS(data: any): AutomatedSaleCreationFailure {
        data = typeof data === 'object' ? data : {};
        let result = new AutomatedSaleCreationFailure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteId"] = this.quoteId;
        data["opportunityId"] = this.opportunityId;
        data["error"] = this.error;
        data["errorCode"] = this.errorCode;
        data["appointmentId"] = this.appointmentId;
        data["serviceAppointmentId"] = this.serviceAppointmentId;
        return data;
    }
}

export interface IAutomatedSaleCreationFailure {
    quoteId: string;
    opportunityId: string;
    error: string | undefined;
    errorCode?: string | undefined;
    appointmentId?: string;
    serviceAppointmentId?: string | undefined;
}

export class AutomatedSaleCreationSuccess implements IAutomatedSaleCreationSuccess {
    quoteId!: string;
    opportunityId!: string;
    saleId!: string;
    appointmentId?: string;
    serviceAppointmentId?: string | undefined;

    constructor(data?: IAutomatedSaleCreationSuccess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data["quoteId"];
            this.opportunityId = _data["opportunityId"];
            this.saleId = _data["saleId"];
            this.appointmentId = _data["appointmentId"];
            this.serviceAppointmentId = _data["serviceAppointmentId"];
        }
    }

    static fromJS(data: any): AutomatedSaleCreationSuccess {
        data = typeof data === 'object' ? data : {};
        let result = new AutomatedSaleCreationSuccess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteId"] = this.quoteId;
        data["opportunityId"] = this.opportunityId;
        data["saleId"] = this.saleId;
        data["appointmentId"] = this.appointmentId;
        data["serviceAppointmentId"] = this.serviceAppointmentId;
        return data;
    }
}

export interface IAutomatedSaleCreationSuccess {
    quoteId: string;
    opportunityId: string;
    saleId: string;
    appointmentId?: string;
    serviceAppointmentId?: string | undefined;
}

export class AzureBlobUploadResult implements IAzureBlobUploadResult {
    fileName!: string | undefined;
    blobUri!: string | undefined;
    sizeInBytes!: number;
    contentType!: string | undefined;
    subfolderPath!: string | undefined;
    fileNameOnServer!: string | undefined;

    constructor(data?: IAzureBlobUploadResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.blobUri = _data["blobUri"];
            this.sizeInBytes = _data["sizeInBytes"];
            this.contentType = _data["contentType"];
            this.subfolderPath = _data["subfolderPath"];
            this.fileNameOnServer = _data["fileNameOnServer"];
        }
    }

    static fromJS(data: any): AzureBlobUploadResult {
        data = typeof data === 'object' ? data : {};
        let result = new AzureBlobUploadResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["blobUri"] = this.blobUri;
        data["sizeInBytes"] = this.sizeInBytes;
        data["contentType"] = this.contentType;
        data["subfolderPath"] = this.subfolderPath;
        data["fileNameOnServer"] = this.fileNameOnServer;
        return data;
    }
}

export interface IAzureBlobUploadResult {
    fileName: string | undefined;
    blobUri: string | undefined;
    sizeInBytes: number;
    contentType: string | undefined;
    subfolderPath: string | undefined;
    fileNameOnServer: string | undefined;
}

export class BranchInfo implements IBranchInfo {
    id?: string;
    legacyZoneId?: number | undefined;
    name?: string | undefined;
    brandId?: string;
    brand?: BrandInfo;
    legacyDealerId?: number | undefined;
    readonly fullBranchName?: string | undefined;
    callbackNumber?: string | undefined;

    constructor(data?: IBranchInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legacyZoneId = _data["legacyZoneId"];
            this.name = _data["name"];
            this.brandId = _data["brandId"];
            this.brand = _data["brand"] ? BrandInfo.fromJS(_data["brand"]) : undefined as any;
            this.legacyDealerId = _data["legacyDealerId"];
            (this as any).fullBranchName = _data["fullBranchName"];
            this.callbackNumber = _data["callbackNumber"];
        }
    }

    static fromJS(data: any): BranchInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BranchInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyZoneId"] = this.legacyZoneId;
        data["name"] = this.name;
        data["brandId"] = this.brandId;
        data["brand"] = this.brand ? this.brand.toJSON() : undefined as any;
        data["legacyDealerId"] = this.legacyDealerId;
        data["fullBranchName"] = this.fullBranchName;
        data["callbackNumber"] = this.callbackNumber;
        return data;
    }
}

export interface IBranchInfo {
    id?: string;
    legacyZoneId?: number | undefined;
    name?: string | undefined;
    brandId?: string;
    brand?: BrandInfo;
    legacyDealerId?: number | undefined;
    fullBranchName?: string | undefined;
    callbackNumber?: string | undefined;
}

export class BrandInfo implements IBrandInfo {
    id?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    salesCallCenterPhoneNumber?: string | undefined;
    serviceCallCenterPhoneNumber?: string | undefined;
    legacyDealerId?: number | undefined;
    isActive?: boolean;

    constructor(data?: IBrandInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.salesCallCenterPhoneNumber = _data["salesCallCenterPhoneNumber"];
            this.serviceCallCenterPhoneNumber = _data["serviceCallCenterPhoneNumber"];
            this.legacyDealerId = _data["legacyDealerId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BrandInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BrandInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["salesCallCenterPhoneNumber"] = this.salesCallCenterPhoneNumber;
        data["serviceCallCenterPhoneNumber"] = this.serviceCallCenterPhoneNumber;
        data["legacyDealerId"] = this.legacyDealerId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IBrandInfo {
    id?: string;
    name?: string | undefined;
    shortName?: string | undefined;
    salesCallCenterPhoneNumber?: string | undefined;
    serviceCallCenterPhoneNumber?: string | undefined;
    legacyDealerId?: number | undefined;
    isActive?: boolean;
}

export enum CalendarAppointmentType {
    Sales = 1,
    Service = 3,
}

export class CalendarByDayInfo implements ICalendarByDayInfo {
    id!: string;
    opportunityId!: string;
    customerId!: number | undefined;
    startAt!: Date;
    endAt!: Date;
    contacts!: AppointmentContactInfo[] | undefined;
    address!: AppointmentAddressInfo;
    geozone!: AppointmentGeozoneInfo;
    appointmentType!: CalendarAppointmentType;
    contact?: AppointmentContactInfo;

    constructor(data?: ICalendarByDayInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.address = new AppointmentAddressInfo();
            this.geozone = new AppointmentGeozoneInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.opportunityId = _data["opportunityId"];
            this.customerId = _data["customerId"];
            this.startAt = _data["startAt"] ? new Date(_data["startAt"].toString()) : undefined as any;
            this.endAt = _data["endAt"] ? new Date(_data["endAt"].toString()) : undefined as any;
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(AppointmentContactInfo.fromJS(item));
            }
            this.address = _data["address"] ? AppointmentAddressInfo.fromJS(_data["address"]) : new AppointmentAddressInfo();
            this.geozone = _data["geozone"] ? AppointmentGeozoneInfo.fromJS(_data["geozone"]) : new AppointmentGeozoneInfo();
            this.appointmentType = _data["appointmentType"];
            this.contact = _data["contact"] ? AppointmentContactInfo.fromJS(_data["contact"]) : undefined as any;
        }
    }

    static fromJS(data: any): CalendarByDayInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarByDayInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["opportunityId"] = this.opportunityId;
        data["customerId"] = this.customerId;
        data["startAt"] = this.startAt ? this.startAt.toISOString() : undefined as any;
        data["endAt"] = this.endAt ? this.endAt.toISOString() : undefined as any;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : undefined as any);
        }
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["geozone"] = this.geozone ? this.geozone.toJSON() : undefined as any;
        data["appointmentType"] = this.appointmentType;
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        return data;
    }
}

export interface ICalendarByDayInfo {
    id: string;
    opportunityId: string;
    customerId: number | undefined;
    startAt: Date;
    endAt: Date;
    contacts: AppointmentContactInfo[] | undefined;
    address: AppointmentAddressInfo;
    geozone: AppointmentGeozoneInfo;
    appointmentType: CalendarAppointmentType;
    contact?: AppointmentContactInfo;
}

export class CondensedQuotes implements ICondensedQuotes {
    quotes!: QuoteInfoCondensed[] | undefined;
    actions!: ActionRefLink[] | undefined;

    constructor(data?: ICondensedQuotes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["quotes"])) {
                this.quotes = [] as any;
                for (let item of _data["quotes"])
                    this.quotes!.push(QuoteInfoCondensed.fromJS(item));
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(ActionRefLink.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CondensedQuotes {
        data = typeof data === 'object' ? data : {};
        let result = new CondensedQuotes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.quotes)) {
            data["quotes"] = [];
            for (let item of this.quotes)
                data["quotes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICondensedQuotes {
    quotes: QuoteInfoCondensed[] | undefined;
    actions: ActionRefLink[] | undefined;
}

export class ContactInfo implements IContactInfo {
    id!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;
    phoneType?: string | undefined;
    email?: string | undefined;
    relationship?: string | undefined;
    isPrimary?: boolean;
    optInToTextUpdates?: boolean | undefined;
    isDoNotCall?: boolean | undefined;
    isDoNotEmail?: boolean | undefined;
    isDoNotSMS?: boolean | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IContactInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.extension = _data["extension"];
            this.phoneType = _data["phoneType"];
            this.email = _data["email"];
            this.relationship = _data["relationship"];
            this.isPrimary = _data["isPrimary"];
            this.optInToTextUpdates = _data["optInToTextUpdates"];
            this.isDoNotCall = _data["isDoNotCall"];
            this.isDoNotEmail = _data["isDoNotEmail"];
            this.isDoNotSMS = _data["isDoNotSMS"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ContactInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["extension"] = this.extension;
        data["phoneType"] = this.phoneType;
        data["email"] = this.email;
        data["relationship"] = this.relationship;
        data["isPrimary"] = this.isPrimary;
        data["optInToTextUpdates"] = this.optInToTextUpdates;
        data["isDoNotCall"] = this.isDoNotCall;
        data["isDoNotEmail"] = this.isDoNotEmail;
        data["isDoNotSMS"] = this.isDoNotSMS;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IContactInfo {
    id: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    extension?: string | undefined;
    phoneType?: string | undefined;
    email?: string | undefined;
    relationship?: string | undefined;
    isPrimary?: boolean;
    optInToTextUpdates?: boolean | undefined;
    isDoNotCall?: boolean | undefined;
    isDoNotEmail?: boolean | undefined;
    isDoNotSMS?: boolean | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
}

export class CreateAppointmentDispositionUpdateRequestDto implements ICreateAppointmentDispositionUpdateRequestDto {
    appointmentId!: string;
    dispositionId!: string;
    subDispositionId!: string;
    dispositionDateEntered!: Date;
    inspectorEmail!: string | undefined;
    opportunityId?: string;

    constructor(data?: ICreateAppointmentDispositionUpdateRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.dispositionId = _data["dispositionId"];
            this.subDispositionId = _data["subDispositionId"];
            this.dispositionDateEntered = _data["dispositionDateEntered"] ? new Date(_data["dispositionDateEntered"].toString()) : undefined as any;
            this.inspectorEmail = _data["inspectorEmail"];
            this.opportunityId = _data["opportunityId"];
        }
    }

    static fromJS(data: any): CreateAppointmentDispositionUpdateRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppointmentDispositionUpdateRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["dispositionId"] = this.dispositionId;
        data["subDispositionId"] = this.subDispositionId;
        data["dispositionDateEntered"] = this.dispositionDateEntered ? this.dispositionDateEntered.toISOString() : undefined as any;
        data["inspectorEmail"] = this.inspectorEmail;
        data["opportunityId"] = this.opportunityId;
        return data;
    }
}

export interface ICreateAppointmentDispositionUpdateRequestDto {
    appointmentId: string;
    dispositionId: string;
    subDispositionId: string;
    dispositionDateEntered: Date;
    inspectorEmail: string | undefined;
    opportunityId?: string;
}

export class CreateAppointmentDispositionUpdateRequestV3Dto implements ICreateAppointmentDispositionUpdateRequestV3Dto {
    dispositionId!: string;
    subDispositionId!: string;
    dispositionDateEntered!: Date;

    constructor(data?: ICreateAppointmentDispositionUpdateRequestV3Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dispositionId = _data["dispositionId"];
            this.subDispositionId = _data["subDispositionId"];
            this.dispositionDateEntered = _data["dispositionDateEntered"] ? new Date(_data["dispositionDateEntered"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateAppointmentDispositionUpdateRequestV3Dto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppointmentDispositionUpdateRequestV3Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dispositionId"] = this.dispositionId;
        data["subDispositionId"] = this.subDispositionId;
        data["dispositionDateEntered"] = this.dispositionDateEntered ? this.dispositionDateEntered.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateAppointmentDispositionUpdateRequestV3Dto {
    dispositionId: string;
    subDispositionId: string;
    dispositionDateEntered: Date;
}

export class CreateAppointmentDispositionUpdateSubmissionDto implements ICreateAppointmentDispositionUpdateSubmissionDto {
    appointmentId!: string;
    dispositionId!: string;
    subDispositionId!: string;
    dispositionDateEntered!: Date;
    opportunityId?: string;

    constructor(data?: ICreateAppointmentDispositionUpdateSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.dispositionId = _data["dispositionId"];
            this.subDispositionId = _data["subDispositionId"];
            this.dispositionDateEntered = _data["dispositionDateEntered"] ? new Date(_data["dispositionDateEntered"].toString()) : undefined as any;
            this.opportunityId = _data["opportunityId"];
        }
    }

    static fromJS(data: any): CreateAppointmentDispositionUpdateSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppointmentDispositionUpdateSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["dispositionId"] = this.dispositionId;
        data["subDispositionId"] = this.subDispositionId;
        data["dispositionDateEntered"] = this.dispositionDateEntered ? this.dispositionDateEntered.toISOString() : undefined as any;
        data["opportunityId"] = this.opportunityId;
        return data;
    }
}

export interface ICreateAppointmentDispositionUpdateSubmissionDto {
    appointmentId: string;
    dispositionId: string;
    subDispositionId: string;
    dispositionDateEntered: Date;
    opportunityId?: string;
}

export class CreateAppointmentSalesTouchpointRequest implements ICreateAppointmentSalesTouchpointRequest {
    appointmentId!: string;
    note!: string | undefined;
    sourceName?: string | undefined;

    constructor(data?: ICreateAppointmentSalesTouchpointRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.note = _data["note"];
            this.sourceName = _data["sourceName"];
        }
    }

    static fromJS(data: any): CreateAppointmentSalesTouchpointRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppointmentSalesTouchpointRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["note"] = this.note;
        data["sourceName"] = this.sourceName;
        return data;
    }
}

export interface ICreateAppointmentSalesTouchpointRequest {
    appointmentId: string;
    note: string | undefined;
    sourceName?: string | undefined;
}

export class CreateAppointmentSalesTouchpointV3Dto implements ICreateAppointmentSalesTouchpointV3Dto {
    appointmentId!: string;
    note!: string | undefined;
    sourceName?: string | undefined;

    constructor(data?: ICreateAppointmentSalesTouchpointV3Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.note = _data["note"];
            this.sourceName = _data["sourceName"];
        }
    }

    static fromJS(data: any): CreateAppointmentSalesTouchpointV3Dto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppointmentSalesTouchpointV3Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["note"] = this.note;
        data["sourceName"] = this.sourceName;
        return data;
    }
}

export interface ICreateAppointmentSalesTouchpointV3Dto {
    appointmentId: string;
    note: string | undefined;
    sourceName?: string | undefined;
}

export class CreateOpportunitySalesTouchpointV3Dto implements ICreateOpportunitySalesTouchpointV3Dto {
    note!: string | undefined;
    sourceName?: string | undefined;

    constructor(data?: ICreateOpportunitySalesTouchpointV3Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
            this.sourceName = _data["sourceName"];
        }
    }

    static fromJS(data: any): CreateOpportunitySalesTouchpointV3Dto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOpportunitySalesTouchpointV3Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["sourceName"] = this.sourceName;
        return data;
    }
}

export interface ICreateOpportunitySalesTouchpointV3Dto {
    note: string | undefined;
    sourceName?: string | undefined;
}

export class CreateSaleRequest implements ICreateSaleRequest {
    opportunityId!: string;
    quoteId!: string;
    saleAmount!: number;
    soldAt!: Date;

    constructor(data?: ICreateSaleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityId = _data["opportunityId"];
            this.quoteId = _data["quoteId"];
            this.saleAmount = _data["saleAmount"];
            this.soldAt = _data["soldAt"] ? new Date(_data["soldAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateSaleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSaleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opportunityId"] = this.opportunityId;
        data["quoteId"] = this.quoteId;
        data["saleAmount"] = this.saleAmount;
        data["soldAt"] = this.soldAt ? this.soldAt.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateSaleRequest {
    opportunityId: string;
    quoteId: string;
    saleAmount: number;
    soldAt: Date;
}

export class CreateSalesTouchpointRequest implements ICreateSalesTouchpointRequest {
    opportunityId!: string;
    note!: string | undefined;
    sourceName?: string | undefined;

    constructor(data?: ICreateSalesTouchpointRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityId = _data["opportunityId"];
            this.note = _data["note"];
            this.sourceName = _data["sourceName"];
        }
    }

    static fromJS(data: any): CreateSalesTouchpointRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSalesTouchpointRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opportunityId"] = this.opportunityId;
        data["note"] = this.note;
        data["sourceName"] = this.sourceName;
        return data;
    }
}

export interface ICreateSalesTouchpointRequest {
    opportunityId: string;
    note: string | undefined;
    sourceName?: string | undefined;
}

export class CreateServiceAppointmentDispositionRequestV3Dto implements ICreateServiceAppointmentDispositionRequestV3Dto {
    dispositionId!: string;
    dispositionDateEntered!: Date;

    constructor(data?: ICreateServiceAppointmentDispositionRequestV3Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dispositionId = _data["dispositionId"];
            this.dispositionDateEntered = _data["dispositionDateEntered"] ? new Date(_data["dispositionDateEntered"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateServiceAppointmentDispositionRequestV3Dto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceAppointmentDispositionRequestV3Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dispositionId"] = this.dispositionId;
        data["dispositionDateEntered"] = this.dispositionDateEntered ? this.dispositionDateEntered.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateServiceAppointmentDispositionRequestV3Dto {
    dispositionId: string;
    dispositionDateEntered: Date;
}

export class CustomerInfo implements ICustomerInfo {
    id?: number;
    primaryContactId?: string;
    addressId?: string;
    createdAt?: Date;
    createdBy?: string | undefined;
    updatedAt?: Date;
    updatedBy?: string | undefined;
    address?: AddressInfo;
    contact?: ContactInfo;

    constructor(data?: ICustomerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.primaryContactId = _data["primaryContactId"];
            this.addressId = _data["addressId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.address = _data["address"] ? AddressInfo.fromJS(_data["address"]) : undefined as any;
            this.contact = _data["contact"] ? ContactInfo.fromJS(_data["contact"]) : undefined as any;
        }
    }

    static fromJS(data: any): CustomerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["primaryContactId"] = this.primaryContactId;
        data["addressId"] = this.addressId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        return data;
    }
}

export interface ICustomerInfo {
    id?: number;
    primaryContactId?: string;
    addressId?: string;
    createdAt?: Date;
    createdBy?: string | undefined;
    updatedAt?: Date;
    updatedBy?: string | undefined;
    address?: AddressInfo;
    contact?: ContactInfo;
}

export class CustomerOpportunitiesInfo implements ICustomerOpportunitiesInfo {
    customerId?: number | undefined;
    customerName?: string | undefined;
    customerSince?: Date | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    address?: AddressInfo;
    opportunities?: CustomerOpportunitySummaryInfo[] | undefined;

    constructor(data?: ICustomerOpportunitiesInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.customerSince = _data["customerSince"] ? new Date(_data["customerSince"].toString()) : undefined as any;
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.address = _data["address"] ? AddressInfo.fromJS(_data["address"]) : undefined as any;
            if (Array.isArray(_data["opportunities"])) {
                this.opportunities = [] as any;
                for (let item of _data["opportunities"])
                    this.opportunities!.push(CustomerOpportunitySummaryInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerOpportunitiesInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOpportunitiesInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["customerSince"] = this.customerSince ? this.customerSince.toISOString() : undefined as any;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        if (Array.isArray(this.opportunities)) {
            data["opportunities"] = [];
            for (let item of this.opportunities)
                data["opportunities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomerOpportunitiesInfo {
    customerId?: number | undefined;
    customerName?: string | undefined;
    customerSince?: Date | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    address?: AddressInfo;
    opportunities?: CustomerOpportunitySummaryInfo[] | undefined;
}

export class CustomerOpportunitySummaryInfo implements ICustomerOpportunitySummaryInfo {
    id!: string;
    opportunityTypeName?: string | undefined;
    phaseName?: string | undefined;
    furthestPhaseName?: string | undefined;
    createdAt!: Date;
    isActive!: boolean;
    isCommercial?: boolean;

    constructor(data?: ICustomerOpportunitySummaryInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.opportunityTypeName = _data["opportunityTypeName"];
            this.phaseName = _data["phaseName"];
            this.furthestPhaseName = _data["furthestPhaseName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.isCommercial = _data["isCommercial"];
        }
    }

    static fromJS(data: any): CustomerOpportunitySummaryInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOpportunitySummaryInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["opportunityTypeName"] = this.opportunityTypeName;
        data["phaseName"] = this.phaseName;
        data["furthestPhaseName"] = this.furthestPhaseName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["isActive"] = this.isActive;
        data["isCommercial"] = this.isCommercial;
        return data;
    }
}

export interface ICustomerOpportunitySummaryInfo {
    id: string;
    opportunityTypeName?: string | undefined;
    phaseName?: string | undefined;
    furthestPhaseName?: string | undefined;
    createdAt: Date;
    isActive: boolean;
    isCommercial?: boolean;
}

export class DeactivateOpportunityRequest implements IDeactivateOpportunityRequest {
    removeReason?: string | undefined;

    constructor(data?: IDeactivateOpportunityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.removeReason = _data["removeReason"];
        }
    }

    static fromJS(data: any): DeactivateOpportunityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeactivateOpportunityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["removeReason"] = this.removeReason;
        return data;
    }
}

export interface IDeactivateOpportunityRequest {
    removeReason?: string | undefined;
}

export class Discount implements IDiscount {
    discountTypeId?: number;
    amount?: number;

    constructor(data?: IDiscount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discountTypeId = _data["discountTypeId"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): Discount {
        data = typeof data === 'object' ? data : {};
        let result = new Discount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountTypeId"] = this.discountTypeId;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IDiscount {
    discountTypeId?: number;
    amount?: number;
}

export class DiscountInfo implements IDiscountInfo {
    id!: string;
    description!: string | undefined;
    amount!: number;
    discountTypeName!: string | undefined;
    discountTypeId!: string;

    constructor(data?: IDiscountInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.discountTypeName = _data["discountTypeName"];
            this.discountTypeId = _data["discountTypeId"];
        }
    }

    static fromJS(data: any): DiscountInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["discountTypeName"] = this.discountTypeName;
        data["discountTypeId"] = this.discountTypeId;
        return data;
    }
}

export interface IDiscountInfo {
    id: string;
    description: string | undefined;
    amount: number;
    discountTypeName: string | undefined;
    discountTypeId: string;
}

export class FeeInfo implements IFeeInfo {
    id!: string;
    feeTypeName!: string | undefined;
    amount!: number;
    description!: string | undefined;

    constructor(data?: IFeeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.feeTypeName = _data["feeTypeName"];
            this.amount = _data["amount"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FeeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FeeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["feeTypeName"] = this.feeTypeName;
        data["amount"] = this.amount;
        data["description"] = this.description;
        return data;
    }
}

export interface IFeeInfo {
    id: string;
    feeTypeName: string | undefined;
    amount: number;
    description: string | undefined;
}

export class Financing implements IFinancing {
    company!: string | undefined;
    plan!: string | undefined;
    amountFinanced!: number;

    constructor(data?: IFinancing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"];
            this.plan = _data["plan"];
            this.amountFinanced = _data["amountFinanced"];
        }
    }

    static fromJS(data: any): Financing {
        data = typeof data === 'object' ? data : {};
        let result = new Financing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["plan"] = this.plan;
        data["amountFinanced"] = this.amountFinanced;
        return data;
    }
}

export interface IFinancing {
    company: string | undefined;
    plan: string | undefined;
    amountFinanced: number;
}

export class FinancingInfo implements IFinancingInfo {
    id!: string;
    isFinancingApproved!: boolean;
    financingCompanyName!: string | undefined;
    financingPlan!: string | undefined;
    financingApprovalNumber?: string | undefined;
    financingPaymentAmount!: number;
    createdAt!: Date;

    constructor(data?: IFinancingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isFinancingApproved = _data["isFinancingApproved"];
            this.financingCompanyName = _data["financingCompanyName"];
            this.financingPlan = _data["financingPlan"];
            this.financingApprovalNumber = _data["financingApprovalNumber"];
            this.financingPaymentAmount = _data["financingPaymentAmount"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): FinancingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FinancingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isFinancingApproved"] = this.isFinancingApproved;
        data["financingCompanyName"] = this.financingCompanyName;
        data["financingPlan"] = this.financingPlan;
        data["financingApprovalNumber"] = this.financingApprovalNumber;
        data["financingPaymentAmount"] = this.financingPaymentAmount;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IFinancingInfo {
    id: string;
    isFinancingApproved: boolean;
    financingCompanyName: string | undefined;
    financingPlan: string | undefined;
    financingApprovalNumber?: string | undefined;
    financingPaymentAmount: number;
    createdAt: Date;
}

export class MissingDispositionInfo implements IMissingDispositionInfo {
    appointmentId!: string;
    customerName!: string | undefined;
    address!: AddressInfo;

    constructor(data?: IMissingDispositionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.address = new AddressInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.customerName = _data["customerName"];
            this.address = _data["address"] ? AddressInfo.fromJS(_data["address"]) : new AddressInfo();
        }
    }

    static fromJS(data: any): MissingDispositionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MissingDispositionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["customerName"] = this.customerName;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        return data;
    }
}

export interface IMissingDispositionInfo {
    appointmentId: string;
    customerName: string | undefined;
    address: AddressInfo;
}

export class MissingDispositionInfoV3 implements IMissingDispositionInfoV3 {
    appointmentId!: string;
    customerName!: string | undefined;
    address!: AddressInfo;
    eventType!: string | undefined;

    constructor(data?: IMissingDispositionInfoV3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.address = new AddressInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.customerName = _data["customerName"];
            this.address = _data["address"] ? AddressInfo.fromJS(_data["address"]) : new AddressInfo();
            this.eventType = _data["eventType"];
        }
    }

    static fromJS(data: any): MissingDispositionInfoV3 {
        data = typeof data === 'object' ? data : {};
        let result = new MissingDispositionInfoV3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["customerName"] = this.customerName;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["eventType"] = this.eventType;
        return data;
    }
}

export interface IMissingDispositionInfoV3 {
    appointmentId: string;
    customerName: string | undefined;
    address: AddressInfo;
    eventType: string | undefined;
}

export class NewContact implements INewContact {
    firstName!: string | undefined;
    lastName!: string | undefined;
    phoneNumber!: string | undefined;
    email?: string | undefined;

    constructor(data?: INewContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): NewContact {
        data = typeof data === 'object' ? data : {};
        let result = new NewContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        return data;
    }
}

export interface INewContact {
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    email?: string | undefined;
}

export class OpportunityInfo implements IOpportunityInfo {
    id?: string;
    addressId?: string;
    isActive?: boolean;
    phaseId?: string;
    legacyCustomerId?: number | undefined;
    customerId?: number | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    geographicalZoneId?: string | undefined;
    opportunityTypeId?: string | undefined;
    servicePlanId?: string | undefined;
    furthestOpportunityPhaseId?: string;
    hasMoved?: boolean;
    isCommercial?: boolean;
    address?: AddressInfo;
    phase?: OpportunityPhaseInfo;
    appointments?: AppointmentInfo[] | undefined;
    serviceAppointments?: ServiceAppointmentInfo[] | undefined;
    contacts?: ContactInfo[] | undefined;
    quotes?: QuoteInfo[] | undefined;
    sales?: SaleInfo[] | undefined;
    leads?: OpportunityLeadInfo[] | undefined;
    customer?: CustomerInfo;
    canSaleBeApproved?: boolean;

    constructor(data?: IOpportunityInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.addressId = _data["addressId"];
            this.isActive = _data["isActive"];
            this.phaseId = _data["phaseId"];
            this.legacyCustomerId = _data["legacyCustomerId"];
            this.customerId = _data["customerId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.geographicalZoneId = _data["geographicalZoneId"];
            this.opportunityTypeId = _data["opportunityTypeId"];
            this.servicePlanId = _data["servicePlanId"];
            this.furthestOpportunityPhaseId = _data["furthestOpportunityPhaseId"];
            this.hasMoved = _data["hasMoved"];
            this.isCommercial = _data["isCommercial"];
            this.address = _data["address"] ? AddressInfo.fromJS(_data["address"]) : undefined as any;
            this.phase = _data["phase"] ? OpportunityPhaseInfo.fromJS(_data["phase"]) : undefined as any;
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments!.push(AppointmentInfo.fromJS(item));
            }
            if (Array.isArray(_data["serviceAppointments"])) {
                this.serviceAppointments = [] as any;
                for (let item of _data["serviceAppointments"])
                    this.serviceAppointments!.push(ServiceAppointmentInfo.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ContactInfo.fromJS(item));
            }
            if (Array.isArray(_data["quotes"])) {
                this.quotes = [] as any;
                for (let item of _data["quotes"])
                    this.quotes!.push(QuoteInfo.fromJS(item));
            }
            if (Array.isArray(_data["sales"])) {
                this.sales = [] as any;
                for (let item of _data["sales"])
                    this.sales!.push(SaleInfo.fromJS(item));
            }
            if (Array.isArray(_data["leads"])) {
                this.leads = [] as any;
                for (let item of _data["leads"])
                    this.leads!.push(OpportunityLeadInfo.fromJS(item));
            }
            this.customer = _data["customer"] ? CustomerInfo.fromJS(_data["customer"]) : undefined as any;
            this.canSaleBeApproved = _data["canSaleBeApproved"];
        }
    }

    static fromJS(data: any): OpportunityInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OpportunityInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["addressId"] = this.addressId;
        data["isActive"] = this.isActive;
        data["phaseId"] = this.phaseId;
        data["legacyCustomerId"] = this.legacyCustomerId;
        data["customerId"] = this.customerId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["geographicalZoneId"] = this.geographicalZoneId;
        data["opportunityTypeId"] = this.opportunityTypeId;
        data["servicePlanId"] = this.servicePlanId;
        data["furthestOpportunityPhaseId"] = this.furthestOpportunityPhaseId;
        data["hasMoved"] = this.hasMoved;
        data["isCommercial"] = this.isCommercial;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["phase"] = this.phase ? this.phase.toJSON() : undefined as any;
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.serviceAppointments)) {
            data["serviceAppointments"] = [];
            for (let item of this.serviceAppointments)
                data["serviceAppointments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.quotes)) {
            data["quotes"] = [];
            for (let item of this.quotes)
                data["quotes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sales)) {
            data["sales"] = [];
            for (let item of this.sales)
                data["sales"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.leads)) {
            data["leads"] = [];
            for (let item of this.leads)
                data["leads"].push(item ? item.toJSON() : undefined as any);
        }
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["canSaleBeApproved"] = this.canSaleBeApproved;
        return data;
    }
}

export interface IOpportunityInfo {
    id?: string;
    addressId?: string;
    isActive?: boolean;
    phaseId?: string;
    legacyCustomerId?: number | undefined;
    customerId?: number | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    geographicalZoneId?: string | undefined;
    opportunityTypeId?: string | undefined;
    servicePlanId?: string | undefined;
    furthestOpportunityPhaseId?: string;
    hasMoved?: boolean;
    isCommercial?: boolean;
    address?: AddressInfo;
    phase?: OpportunityPhaseInfo;
    appointments?: AppointmentInfo[] | undefined;
    serviceAppointments?: ServiceAppointmentInfo[] | undefined;
    contacts?: ContactInfo[] | undefined;
    quotes?: QuoteInfo[] | undefined;
    sales?: SaleInfo[] | undefined;
    leads?: OpportunityLeadInfo[] | undefined;
    customer?: CustomerInfo;
    canSaleBeApproved?: boolean;
}

export class OpportunityLeadInfo implements IOpportunityLeadInfo {
    leadId!: string;
    opportunityId?: string | undefined;
    mediumId?: number | undefined;
    mediumName?: string | undefined;
    createdAt?: Date;

    constructor(data?: IOpportunityLeadInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leadId = _data["leadId"];
            this.opportunityId = _data["opportunityId"];
            this.mediumId = _data["mediumId"];
            this.mediumName = _data["mediumName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OpportunityLeadInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OpportunityLeadInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leadId"] = this.leadId;
        data["opportunityId"] = this.opportunityId;
        data["mediumId"] = this.mediumId;
        data["mediumName"] = this.mediumName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IOpportunityLeadInfo {
    leadId: string;
    opportunityId?: string | undefined;
    mediumId?: number | undefined;
    mediumName?: string | undefined;
    createdAt?: Date;
}

export class OpportunityPhaseInfo implements IOpportunityPhaseInfo {
    id!: string;
    name!: string | undefined;
    ordinal?: number | undefined;

    constructor(data?: IOpportunityPhaseInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ordinal = _data["ordinal"];
        }
    }

    static fromJS(data: any): OpportunityPhaseInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OpportunityPhaseInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ordinal"] = this.ordinal;
        return data;
    }
}

export interface IOpportunityPhaseInfo {
    id: string;
    name: string | undefined;
    ordinal?: number | undefined;
}

export class PaymentInfo implements IPaymentInfo {
    id!: string;
    opportunityId!: string;
    amount!: number;
    paymentDate!: Date;
    paymentTypeId!: string;
    createdAt!: Date;
    legacyPaymentMethodName?: string | undefined;
    paymentMethodName?: string | undefined;

    constructor(data?: IPaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.opportunityId = _data["opportunityId"];
            this.amount = _data["amount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined as any;
            this.paymentTypeId = _data["paymentTypeId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.legacyPaymentMethodName = _data["legacyPaymentMethodName"];
            this.paymentMethodName = _data["paymentMethodName"];
        }
    }

    static fromJS(data: any): PaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["opportunityId"] = this.opportunityId;
        data["amount"] = this.amount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined as any;
        data["paymentTypeId"] = this.paymentTypeId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["legacyPaymentMethodName"] = this.legacyPaymentMethodName;
        data["paymentMethodName"] = this.paymentMethodName;
        return data;
    }
}

export interface IPaymentInfo {
    id: string;
    opportunityId: string;
    amount: number;
    paymentDate: Date;
    paymentTypeId: string;
    createdAt: Date;
    legacyPaymentMethodName?: string | undefined;
    paymentMethodName?: string | undefined;
}

export class PaymentLineItem implements IPaymentLineItem {
    date!: Date;
    amount!: number;
    label?: string | undefined;

    constructor(data?: IPaymentLineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.amount = _data["amount"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): PaymentLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["amount"] = this.amount;
        data["label"] = this.label;
        return data;
    }
}

export interface IPaymentLineItem {
    date: Date;
    amount: number;
    label?: string | undefined;
}

export class PaymentMethodInfo implements IPaymentMethodInfo {
    id!: string;
    name!: string | undefined;

    constructor(data?: IPaymentMethodInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PaymentMethodInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPaymentMethodInfo {
    id: string;
    name: string | undefined;
}

export class PaymentSummary implements IPaymentSummary {
    payments!: PaymentLineItem[] | undefined;
    pendingCredits!: PaymentLineItem[] | undefined;
    paymentsReceived!: number;
    totalBalanceDue!: number | undefined;
    amountDueNow?: number | undefined;

    constructor(data?: IPaymentSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(PaymentLineItem.fromJS(item));
            }
            if (Array.isArray(_data["pendingCredits"])) {
                this.pendingCredits = [] as any;
                for (let item of _data["pendingCredits"])
                    this.pendingCredits!.push(PaymentLineItem.fromJS(item));
            }
            this.paymentsReceived = _data["paymentsReceived"];
            this.totalBalanceDue = _data["totalBalanceDue"];
            this.amountDueNow = _data["amountDueNow"];
        }
    }

    static fromJS(data: any): PaymentSummary {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.pendingCredits)) {
            data["pendingCredits"] = [];
            for (let item of this.pendingCredits)
                data["pendingCredits"].push(item ? item.toJSON() : undefined as any);
        }
        data["paymentsReceived"] = this.paymentsReceived;
        data["totalBalanceDue"] = this.totalBalanceDue;
        data["amountDueNow"] = this.amountDueNow;
        return data;
    }
}

export interface IPaymentSummary {
    payments: PaymentLineItem[] | undefined;
    pendingCredits: PaymentLineItem[] | undefined;
    paymentsReceived: number;
    totalBalanceDue: number | undefined;
    amountDueNow?: number | undefined;
}

export class PendingSaleAppointmentDispositionInfo implements IPendingSaleAppointmentDispositionInfo {
    appointmentId?: string;
    legacyAppointmentId?: number | undefined;
    appointmentDispositionId?: string;
    appointmentSubDispositionId?: string;
    updatedBy?: string | undefined;

    constructor(data?: IPendingSaleAppointmentDispositionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.legacyAppointmentId = _data["legacyAppointmentId"];
            this.appointmentDispositionId = _data["appointmentDispositionId"];
            this.appointmentSubDispositionId = _data["appointmentSubDispositionId"];
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): PendingSaleAppointmentDispositionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PendingSaleAppointmentDispositionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["legacyAppointmentId"] = this.legacyAppointmentId;
        data["appointmentDispositionId"] = this.appointmentDispositionId;
        data["appointmentSubDispositionId"] = this.appointmentSubDispositionId;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IPendingSaleAppointmentDispositionInfo {
    appointmentId?: string;
    legacyAppointmentId?: number | undefined;
    appointmentDispositionId?: string;
    appointmentSubDispositionId?: string;
    updatedBy?: string | undefined;
}

export class PendingSaleInfo implements IPendingSaleInfo {
    id!: string;
    appointmentId!: string;
    quoteId!: string;
    branch!: string | undefined;
    customerName!: string | undefined;
    appointmentType!: string | undefined;
    saleDate!: Date;
    saleAmount!: number;
    cfiName!: string | undefined;

    constructor(data?: IPendingSaleInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appointmentId = _data["appointmentId"];
            this.quoteId = _data["quoteId"];
            this.branch = _data["branch"];
            this.customerName = _data["customerName"];
            this.appointmentType = _data["appointmentType"];
            this.saleDate = _data["saleDate"] ? new Date(_data["saleDate"].toString()) : undefined as any;
            this.saleAmount = _data["saleAmount"];
            this.cfiName = _data["cfiName"];
        }
    }

    static fromJS(data: any): PendingSaleInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PendingSaleInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appointmentId"] = this.appointmentId;
        data["quoteId"] = this.quoteId;
        data["branch"] = this.branch;
        data["customerName"] = this.customerName;
        data["appointmentType"] = this.appointmentType;
        data["saleDate"] = this.saleDate ? this.saleDate.toISOString() : undefined as any;
        data["saleAmount"] = this.saleAmount;
        data["cfiName"] = this.cfiName;
        return data;
    }
}

export interface IPendingSaleInfo {
    id: string;
    appointmentId: string;
    quoteId: string;
    branch: string | undefined;
    customerName: string | undefined;
    appointmentType: string | undefined;
    saleDate: Date;
    saleAmount: number;
    cfiName: string | undefined;
}

export class PendingSalesListboxInfo implements IPendingSalesListboxInfo {
    pendingSales!: PendingSaleInfo[] | undefined;
    completedSales!: PendingSaleInfo[] | undefined;
    serviceSalesToApprove!: PendingSaleInfo[] | undefined;

    constructor(data?: IPendingSalesListboxInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pendingSales"])) {
                this.pendingSales = [] as any;
                for (let item of _data["pendingSales"])
                    this.pendingSales!.push(PendingSaleInfo.fromJS(item));
            }
            if (Array.isArray(_data["completedSales"])) {
                this.completedSales = [] as any;
                for (let item of _data["completedSales"])
                    this.completedSales!.push(PendingSaleInfo.fromJS(item));
            }
            if (Array.isArray(_data["serviceSalesToApprove"])) {
                this.serviceSalesToApprove = [] as any;
                for (let item of _data["serviceSalesToApprove"])
                    this.serviceSalesToApprove!.push(PendingSaleInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PendingSalesListboxInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PendingSalesListboxInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pendingSales)) {
            data["pendingSales"] = [];
            for (let item of this.pendingSales)
                data["pendingSales"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.completedSales)) {
            data["completedSales"] = [];
            for (let item of this.completedSales)
                data["completedSales"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.serviceSalesToApprove)) {
            data["serviceSalesToApprove"] = [];
            for (let item of this.serviceSalesToApprove)
                data["serviceSalesToApprove"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPendingSalesListboxInfo {
    pendingSales: PendingSaleInfo[] | undefined;
    completedSales: PendingSaleInfo[] | undefined;
    serviceSalesToApprove: PendingSaleInfo[] | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class Product implements IProduct {
    productId?: number;
    quotedQuantity?: number;
    quotedUnitAmount?: number;
    quotedSubtotal?: number;
    recommendedQuantity?: number;
    recommendedUnitAmount?: number;
    recommendedSubtotal?: number;
    isRateOverridden?: boolean;
    notes?: string | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.quotedQuantity = _data["quotedQuantity"];
            this.quotedUnitAmount = _data["quotedUnitAmount"];
            this.quotedSubtotal = _data["quotedSubtotal"];
            this.recommendedQuantity = _data["recommendedQuantity"];
            this.recommendedUnitAmount = _data["recommendedUnitAmount"];
            this.recommendedSubtotal = _data["recommendedSubtotal"];
            this.isRateOverridden = _data["isRateOverridden"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["quotedQuantity"] = this.quotedQuantity;
        data["quotedUnitAmount"] = this.quotedUnitAmount;
        data["quotedSubtotal"] = this.quotedSubtotal;
        data["recommendedQuantity"] = this.recommendedQuantity;
        data["recommendedUnitAmount"] = this.recommendedUnitAmount;
        data["recommendedSubtotal"] = this.recommendedSubtotal;
        data["isRateOverridden"] = this.isRateOverridden;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IProduct {
    productId?: number;
    quotedQuantity?: number;
    quotedUnitAmount?: number;
    quotedSubtotal?: number;
    recommendedQuantity?: number;
    recommendedUnitAmount?: number;
    recommendedSubtotal?: number;
    isRateOverridden?: boolean;
    notes?: string | undefined;
}

export class ProductInfo implements IProductInfo {
    id!: string;
    name!: string | undefined;
    unitOfMeasure!: string | undefined;
    parPrice!: number;

    constructor(data?: IProductInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.parPrice = _data["parPrice"];
        }
    }

    static fromJS(data: any): ProductInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["parPrice"] = this.parPrice;
        return data;
    }
}

export interface IProductInfo {
    id: string;
    name: string | undefined;
    unitOfMeasure: string | undefined;
    parPrice: number;
}

export class QuoteInfo implements IQuoteInfo {
    id!: string;
    name!: string | undefined;
    wasFinancingOffered!: boolean;
    saleAmount!: number;
    soldAt?: Date | undefined;
    systemVerifiedSaleApprovalItems?: SaleApprovalChecklistItems;
    completedSaleApprovalItems?: SaleApprovalChecklistItems;
    quotedProducts?: QuoteProductInfo[] | undefined;
    recommendedProducts?: QuoteProductInfo[] | undefined;
    recurringProducts?: QuoteProductInfo[] | undefined;
    productTotal?: number;
    subTotal?: number;
    parSubTotal?: number;
    soldTotal?: number;
    parTotal?: number;
    createdAt?: Date | undefined;
    fees?: FeeInfo[] | undefined;
    discounts?: DiscountInfo[] | undefined;
    tax?: TaxInfo;
    financing?: FinancingInfo;
    sale?: SaleInfo;

    constructor(data?: IQuoteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.wasFinancingOffered = _data["wasFinancingOffered"];
            this.saleAmount = _data["saleAmount"];
            this.soldAt = _data["soldAt"] ? new Date(_data["soldAt"].toString()) : undefined as any;
            this.systemVerifiedSaleApprovalItems = _data["systemVerifiedSaleApprovalItems"];
            this.completedSaleApprovalItems = _data["completedSaleApprovalItems"];
            if (Array.isArray(_data["quotedProducts"])) {
                this.quotedProducts = [] as any;
                for (let item of _data["quotedProducts"])
                    this.quotedProducts!.push(QuoteProductInfo.fromJS(item));
            }
            if (Array.isArray(_data["recommendedProducts"])) {
                this.recommendedProducts = [] as any;
                for (let item of _data["recommendedProducts"])
                    this.recommendedProducts!.push(QuoteProductInfo.fromJS(item));
            }
            if (Array.isArray(_data["recurringProducts"])) {
                this.recurringProducts = [] as any;
                for (let item of _data["recurringProducts"])
                    this.recurringProducts!.push(QuoteProductInfo.fromJS(item));
            }
            this.productTotal = _data["productTotal"];
            this.subTotal = _data["subTotal"];
            this.parSubTotal = _data["parSubTotal"];
            this.soldTotal = _data["soldTotal"];
            this.parTotal = _data["parTotal"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            if (Array.isArray(_data["fees"])) {
                this.fees = [] as any;
                for (let item of _data["fees"])
                    this.fees!.push(FeeInfo.fromJS(item));
            }
            if (Array.isArray(_data["discounts"])) {
                this.discounts = [] as any;
                for (let item of _data["discounts"])
                    this.discounts!.push(DiscountInfo.fromJS(item));
            }
            this.tax = _data["tax"] ? TaxInfo.fromJS(_data["tax"]) : undefined as any;
            this.financing = _data["financing"] ? FinancingInfo.fromJS(_data["financing"]) : undefined as any;
            this.sale = _data["sale"] ? SaleInfo.fromJS(_data["sale"]) : undefined as any;
        }
    }

    static fromJS(data: any): QuoteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["wasFinancingOffered"] = this.wasFinancingOffered;
        data["saleAmount"] = this.saleAmount;
        data["soldAt"] = this.soldAt ? this.soldAt.toISOString() : undefined as any;
        data["systemVerifiedSaleApprovalItems"] = this.systemVerifiedSaleApprovalItems;
        data["completedSaleApprovalItems"] = this.completedSaleApprovalItems;
        if (Array.isArray(this.quotedProducts)) {
            data["quotedProducts"] = [];
            for (let item of this.quotedProducts)
                data["quotedProducts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.recommendedProducts)) {
            data["recommendedProducts"] = [];
            for (let item of this.recommendedProducts)
                data["recommendedProducts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.recurringProducts)) {
            data["recurringProducts"] = [];
            for (let item of this.recurringProducts)
                data["recurringProducts"].push(item ? item.toJSON() : undefined as any);
        }
        data["productTotal"] = this.productTotal;
        data["subTotal"] = this.subTotal;
        data["parSubTotal"] = this.parSubTotal;
        data["soldTotal"] = this.soldTotal;
        data["parTotal"] = this.parTotal;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        if (Array.isArray(this.fees)) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.discounts)) {
            data["discounts"] = [];
            for (let item of this.discounts)
                data["discounts"].push(item ? item.toJSON() : undefined as any);
        }
        data["tax"] = this.tax ? this.tax.toJSON() : undefined as any;
        data["financing"] = this.financing ? this.financing.toJSON() : undefined as any;
        data["sale"] = this.sale ? this.sale.toJSON() : undefined as any;
        return data;
    }
}

export interface IQuoteInfo {
    id: string;
    name: string | undefined;
    wasFinancingOffered: boolean;
    saleAmount: number;
    soldAt?: Date | undefined;
    systemVerifiedSaleApprovalItems?: SaleApprovalChecklistItems;
    completedSaleApprovalItems?: SaleApprovalChecklistItems;
    quotedProducts?: QuoteProductInfo[] | undefined;
    recommendedProducts?: QuoteProductInfo[] | undefined;
    recurringProducts?: QuoteProductInfo[] | undefined;
    productTotal?: number;
    subTotal?: number;
    parSubTotal?: number;
    soldTotal?: number;
    parTotal?: number;
    createdAt?: Date | undefined;
    fees?: FeeInfo[] | undefined;
    discounts?: DiscountInfo[] | undefined;
    tax?: TaxInfo;
    financing?: FinancingInfo;
    sale?: SaleInfo;
}

export class QuoteInfoCondensed implements IQuoteInfoCondensed {
    id!: string;
    createdBy!: string | undefined;
    createdByName!: string | undefined;
    createdAt!: Date;
    saleAmount!: number;
    sale?: SaleInfoCondensed;

    constructor(data?: IQuoteInfoCondensed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdByName = _data["createdByName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.saleAmount = _data["saleAmount"];
            this.sale = _data["sale"] ? SaleInfoCondensed.fromJS(_data["sale"]) : undefined as any;
        }
    }

    static fromJS(data: any): QuoteInfoCondensed {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteInfoCondensed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdByName"] = this.createdByName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["saleAmount"] = this.saleAmount;
        data["sale"] = this.sale ? this.sale.toJSON() : undefined as any;
        return data;
    }
}

export interface IQuoteInfoCondensed {
    id: string;
    createdBy: string | undefined;
    createdByName: string | undefined;
    createdAt: Date;
    saleAmount: number;
    sale?: SaleInfoCondensed;
}

export class QuoteProductInfo implements IQuoteProductInfo {
    id!: string;
    quantity!: number;
    unitAmount!: number;
    subtotal!: number;
    isRateOverridden!: boolean;
    notes!: string | undefined;
    installationPhaseId!: string;
    installationPhaseName!: string | undefined;
    productName!: string | undefined;
    quoteProductTypeId!: string;
    parPerUnit?: number | undefined;
    product?: ProductInfo;

    constructor(data?: IQuoteProductInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
            this.unitAmount = _data["unitAmount"];
            this.subtotal = _data["subtotal"];
            this.isRateOverridden = _data["isRateOverridden"];
            this.notes = _data["notes"];
            this.installationPhaseId = _data["installationPhaseId"];
            this.installationPhaseName = _data["installationPhaseName"];
            this.productName = _data["productName"];
            this.quoteProductTypeId = _data["quoteProductTypeId"];
            this.parPerUnit = _data["parPerUnit"];
            this.product = _data["product"] ? ProductInfo.fromJS(_data["product"]) : undefined as any;
        }
    }

    static fromJS(data: any): QuoteProductInfo {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteProductInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        data["unitAmount"] = this.unitAmount;
        data["subtotal"] = this.subtotal;
        data["isRateOverridden"] = this.isRateOverridden;
        data["notes"] = this.notes;
        data["installationPhaseId"] = this.installationPhaseId;
        data["installationPhaseName"] = this.installationPhaseName;
        data["productName"] = this.productName;
        data["quoteProductTypeId"] = this.quoteProductTypeId;
        data["parPerUnit"] = this.parPerUnit;
        data["product"] = this.product ? this.product.toJSON() : undefined as any;
        return data;
    }
}

export interface IQuoteProductInfo {
    id: string;
    quantity: number;
    unitAmount: number;
    subtotal: number;
    isRateOverridden: boolean;
    notes: string | undefined;
    installationPhaseId: string;
    installationPhaseName: string | undefined;
    productName: string | undefined;
    quoteProductTypeId: string;
    parPerUnit?: number | undefined;
    product?: ProductInfo;
}

export class QuoteRequest implements IQuoteRequest {
    opportunityId?: string;
    startDate?: Date;
    endDate?: Date;
    appointmentTypeId?: string;
    leadTypeId?: string;
    geoZoneId?: string;
    branchId?: string;

    constructor(data?: IQuoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityId = _data["opportunityId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.appointmentTypeId = _data["appointmentTypeId"];
            this.leadTypeId = _data["leadTypeId"];
            this.geoZoneId = _data["geoZoneId"];
            this.branchId = _data["branchId"];
        }
    }

    static fromJS(data: any): QuoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opportunityId"] = this.opportunityId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["appointmentTypeId"] = this.appointmentTypeId;
        data["leadTypeId"] = this.leadTypeId;
        data["geoZoneId"] = this.geoZoneId;
        data["branchId"] = this.branchId;
        return data;
    }
}

export interface IQuoteRequest {
    opportunityId?: string;
    startDate?: Date;
    endDate?: Date;
    appointmentTypeId?: string;
    leadTypeId?: string;
    geoZoneId?: string;
    branchId?: string;
}

export class QuotesListboxInfo implements IQuotesListboxInfo {
    quotesReview!: QuotesReviewInfo[] | undefined;
    serviceQuotesReview?: QuotesReviewInfo[] | undefined;

    constructor(data?: IQuotesListboxInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["quotesReview"])) {
                this.quotesReview = [] as any;
                for (let item of _data["quotesReview"])
                    this.quotesReview!.push(QuotesReviewInfo.fromJS(item));
            }
            if (Array.isArray(_data["serviceQuotesReview"])) {
                this.serviceQuotesReview = [] as any;
                for (let item of _data["serviceQuotesReview"])
                    this.serviceQuotesReview!.push(QuotesReviewInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuotesListboxInfo {
        data = typeof data === 'object' ? data : {};
        let result = new QuotesListboxInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.quotesReview)) {
            data["quotesReview"] = [];
            for (let item of this.quotesReview)
                data["quotesReview"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.serviceQuotesReview)) {
            data["serviceQuotesReview"] = [];
            for (let item of this.serviceQuotesReview)
                data["serviceQuotesReview"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IQuotesListboxInfo {
    quotesReview: QuotesReviewInfo[] | undefined;
    serviceQuotesReview?: QuotesReviewInfo[] | undefined;
}

export class QuotesReviewInfo implements IQuotesReviewInfo {
    id!: string;
    branch!: string | undefined;
    customerName!: string | undefined;
    quoteDate!: Date;
    quoteAmount!: number;
    cfiName!: string | undefined;
    appointmentDate!: Date;
    disposition!: string | undefined;
    subDisposition!: string | undefined;

    constructor(data?: IQuotesReviewInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.branch = _data["branch"];
            this.customerName = _data["customerName"];
            this.quoteDate = _data["quoteDate"] ? new Date(_data["quoteDate"].toString()) : undefined as any;
            this.quoteAmount = _data["quoteAmount"];
            this.cfiName = _data["cfiName"];
            this.appointmentDate = _data["appointmentDate"] ? new Date(_data["appointmentDate"].toString()) : undefined as any;
            this.disposition = _data["disposition"];
            this.subDisposition = _data["subDisposition"];
        }
    }

    static fromJS(data: any): QuotesReviewInfo {
        data = typeof data === 'object' ? data : {};
        let result = new QuotesReviewInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["branch"] = this.branch;
        data["customerName"] = this.customerName;
        data["quoteDate"] = this.quoteDate ? this.quoteDate.toISOString() : undefined as any;
        data["quoteAmount"] = this.quoteAmount;
        data["cfiName"] = this.cfiName;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : undefined as any;
        data["disposition"] = this.disposition;
        data["subDisposition"] = this.subDisposition;
        return data;
    }
}

export interface IQuotesReviewInfo {
    id: string;
    branch: string | undefined;
    customerName: string | undefined;
    quoteDate: Date;
    quoteAmount: number;
    cfiName: string | undefined;
    appointmentDate: Date;
    disposition: string | undefined;
    subDisposition: string | undefined;
}

export class RecordManualPaymentRequest implements IRecordManualPaymentRequest {
    opportunityId!: string;
    amount!: number;
    paymentDate!: Date;
    paymentMethodId!: string;
    checkNumber?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IRecordManualPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityId = _data["opportunityId"];
            this.amount = _data["amount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined as any;
            this.paymentMethodId = _data["paymentMethodId"];
            this.checkNumber = _data["checkNumber"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): RecordManualPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecordManualPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opportunityId"] = this.opportunityId;
        data["amount"] = this.amount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined as any;
        data["paymentMethodId"] = this.paymentMethodId;
        data["checkNumber"] = this.checkNumber;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IRecordManualPaymentRequest {
    opportunityId: string;
    amount: number;
    paymentDate: Date;
    paymentMethodId: string;
    checkNumber?: string | undefined;
    notes?: string | undefined;
}

export enum SaleApprovalChecklistItems {
    None = 0,
    TableConsult = 1,
    Pictures = 2,
    Sketch = 4,
    Contract = 8,
    FinancingDocumentation = 16,
    PermitAndEngineeringForms = 32,
    Notes = 64,
    FlightPlan = 128,
}

export class SaleInfo implements ISaleInfo {
    id!: string;
    opportunityId?: string;
    quoteId?: string;
    branchId?: string;
    saleAmount!: number;
    createdBy!: string | undefined;
    soldAt?: Date | undefined;
    isReviewed?: boolean;
    isCancelled?: boolean;
    cancelledAt?: Date | undefined;
    cancelledBy?: string | undefined;
    saleCancelReasonId?: string | undefined;
    isDeleted?: boolean;
    changeOrderId?: string | undefined;
    isSelfGen?: boolean;

    constructor(data?: ISaleInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.opportunityId = _data["opportunityId"];
            this.quoteId = _data["quoteId"];
            this.branchId = _data["branchId"];
            this.saleAmount = _data["saleAmount"];
            this.createdBy = _data["createdBy"];
            this.soldAt = _data["soldAt"] ? new Date(_data["soldAt"].toString()) : undefined as any;
            this.isReviewed = _data["isReviewed"];
            this.isCancelled = _data["isCancelled"];
            this.cancelledAt = _data["cancelledAt"] ? new Date(_data["cancelledAt"].toString()) : undefined as any;
            this.cancelledBy = _data["cancelledBy"];
            this.saleCancelReasonId = _data["saleCancelReasonId"];
            this.isDeleted = _data["isDeleted"];
            this.changeOrderId = _data["changeOrderId"];
            this.isSelfGen = _data["isSelfGen"];
        }
    }

    static fromJS(data: any): SaleInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["opportunityId"] = this.opportunityId;
        data["quoteId"] = this.quoteId;
        data["branchId"] = this.branchId;
        data["saleAmount"] = this.saleAmount;
        data["createdBy"] = this.createdBy;
        data["soldAt"] = this.soldAt ? this.soldAt.toISOString() : undefined as any;
        data["isReviewed"] = this.isReviewed;
        data["isCancelled"] = this.isCancelled;
        data["cancelledAt"] = this.cancelledAt ? this.cancelledAt.toISOString() : undefined as any;
        data["cancelledBy"] = this.cancelledBy;
        data["saleCancelReasonId"] = this.saleCancelReasonId;
        data["isDeleted"] = this.isDeleted;
        data["changeOrderId"] = this.changeOrderId;
        data["isSelfGen"] = this.isSelfGen;
        return data;
    }
}

export interface ISaleInfo {
    id: string;
    opportunityId?: string;
    quoteId?: string;
    branchId?: string;
    saleAmount: number;
    createdBy: string | undefined;
    soldAt?: Date | undefined;
    isReviewed?: boolean;
    isCancelled?: boolean;
    cancelledAt?: Date | undefined;
    cancelledBy?: string | undefined;
    saleCancelReasonId?: string | undefined;
    isDeleted?: boolean;
    changeOrderId?: string | undefined;
    isSelfGen?: boolean;
}

export class SaleInfoCondensed implements ISaleInfoCondensed {
    id!: string;
    createdByName!: string | undefined;
    createdAt!: Date;
    soldAmount!: number;
    soldAt?: Date | undefined;

    constructor(data?: ISaleInfoCondensed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdByName = _data["createdByName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.soldAmount = _data["soldAmount"];
            this.soldAt = _data["soldAt"] ? new Date(_data["soldAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SaleInfoCondensed {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInfoCondensed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdByName"] = this.createdByName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["soldAmount"] = this.soldAmount;
        data["soldAt"] = this.soldAt ? this.soldAt.toISOString() : undefined as any;
        return data;
    }
}

export interface ISaleInfoCondensed {
    id: string;
    createdByName: string | undefined;
    createdAt: Date;
    soldAmount: number;
    soldAt?: Date | undefined;
}

export class SalesTouchpointInfo implements ISalesTouchpointInfo {
    id!: string;
    opportunityId!: string;
    note!: string | undefined;
    userId!: string;
    userName?: string | undefined;
    sourceName?: string | undefined;
    createdAt!: Date;
    createdByLegacyUserId?: number | undefined;

    constructor(data?: ISalesTouchpointInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.opportunityId = _data["opportunityId"];
            this.note = _data["note"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.sourceName = _data["sourceName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdByLegacyUserId = _data["createdByLegacyUserId"];
        }
    }

    static fromJS(data: any): SalesTouchpointInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SalesTouchpointInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["opportunityId"] = this.opportunityId;
        data["note"] = this.note;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["sourceName"] = this.sourceName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdByLegacyUserId"] = this.createdByLegacyUserId;
        return data;
    }
}

export interface ISalesTouchpointInfo {
    id: string;
    opportunityId: string;
    note: string | undefined;
    userId: string;
    userName?: string | undefined;
    sourceName?: string | undefined;
    createdAt: Date;
    createdByLegacyUserId?: number | undefined;
}

export class SendDepositRequest implements ISendDepositRequest {
    opportunityId!: string;
    customerId!: number;
    amount!: number;
    newContact?: NewContact;

    constructor(data?: ISendDepositRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityId = _data["opportunityId"];
            this.customerId = _data["customerId"];
            this.amount = _data["amount"];
            this.newContact = _data["newContact"] ? NewContact.fromJS(_data["newContact"]) : undefined as any;
        }
    }

    static fromJS(data: any): SendDepositRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendDepositRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opportunityId"] = this.opportunityId;
        data["customerId"] = this.customerId;
        data["amount"] = this.amount;
        data["newContact"] = this.newContact ? this.newContact.toJSON() : undefined as any;
        return data;
    }
}

export interface ISendDepositRequest {
    opportunityId: string;
    customerId: number;
    amount: number;
    newContact?: NewContact;
}

export class SendDepositResult implements ISendDepositResult {
    executionId!: string;
    businessProcessId?: string | undefined;
    status!: string | undefined;
    amount!: number;
    currency!: string | undefined;
    declineReason?: string | undefined;

    constructor(data?: ISendDepositResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.executionId = _data["executionId"];
            this.businessProcessId = _data["businessProcessId"];
            this.status = _data["status"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.declineReason = _data["declineReason"];
        }
    }

    static fromJS(data: any): SendDepositResult {
        data = typeof data === 'object' ? data : {};
        let result = new SendDepositResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["executionId"] = this.executionId;
        data["businessProcessId"] = this.businessProcessId;
        data["status"] = this.status;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["declineReason"] = this.declineReason;
        return data;
    }
}

export interface ISendDepositResult {
    executionId: string;
    businessProcessId?: string | undefined;
    status: string | undefined;
    amount: number;
    currency: string | undefined;
    declineReason?: string | undefined;
}

export class ServiceAppointmentDispositionInfo implements IServiceAppointmentDispositionInfo {
    appointmentId!: string;
    dispositionId!: string;
    updatedBy!: string | undefined;
    updatedAt!: Date;

    constructor(data?: IServiceAppointmentDispositionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.dispositionId = _data["dispositionId"];
            this.updatedBy = _data["updatedBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceAppointmentDispositionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAppointmentDispositionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["dispositionId"] = this.dispositionId;
        data["updatedBy"] = this.updatedBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IServiceAppointmentDispositionInfo {
    appointmentId: string;
    dispositionId: string;
    updatedBy: string | undefined;
    updatedAt: Date;
}

export class ServiceAppointmentInfo implements IServiceAppointmentInfo {
    id?: string;
    opportunityId?: string;
    serviceTechId?: string;
    serviceTechName?: string | undefined;
    branchId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    dispositionId?: string | undefined;
    dispositionName?: string | undefined;
    leadTypeId?: string | undefined;
    leadTypeName?: string | undefined;
    isCancelled?: boolean;
    isBestFit?: boolean;
    isDeleted?: boolean;
    legacyAppointmentId?: number | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IServiceAppointmentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.opportunityId = _data["opportunityId"];
            this.serviceTechId = _data["serviceTechId"];
            this.serviceTechName = _data["serviceTechName"];
            this.branchId = _data["branchId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.dispositionId = _data["dispositionId"];
            this.dispositionName = _data["dispositionName"];
            this.leadTypeId = _data["leadTypeId"];
            this.leadTypeName = _data["leadTypeName"];
            this.isCancelled = _data["isCancelled"];
            this.isBestFit = _data["isBestFit"];
            this.isDeleted = _data["isDeleted"];
            this.legacyAppointmentId = _data["legacyAppointmentId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ServiceAppointmentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAppointmentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["opportunityId"] = this.opportunityId;
        data["serviceTechId"] = this.serviceTechId;
        data["serviceTechName"] = this.serviceTechName;
        data["branchId"] = this.branchId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["dispositionId"] = this.dispositionId;
        data["dispositionName"] = this.dispositionName;
        data["leadTypeId"] = this.leadTypeId;
        data["leadTypeName"] = this.leadTypeName;
        data["isCancelled"] = this.isCancelled;
        data["isBestFit"] = this.isBestFit;
        data["isDeleted"] = this.isDeleted;
        data["legacyAppointmentId"] = this.legacyAppointmentId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IServiceAppointmentInfo {
    id?: string;
    opportunityId?: string;
    serviceTechId?: string;
    serviceTechName?: string | undefined;
    branchId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    dispositionId?: string | undefined;
    dispositionName?: string | undefined;
    leadTypeId?: string | undefined;
    leadTypeName?: string | undefined;
    isCancelled?: boolean;
    isBestFit?: boolean;
    isDeleted?: boolean;
    legacyAppointmentId?: number | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    updatedAt?: Date | undefined;
    updatedBy?: string | undefined;
}

export class ServiceDispositionItemInfo implements IServiceDispositionItemInfo {
    id!: string;
    name!: string | undefined;

    constructor(data?: IServiceDispositionItemInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ServiceDispositionItemInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDispositionItemInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IServiceDispositionItemInfo {
    id: string;
    name: string | undefined;
}

export class SingleFileUploadResult implements ISingleFileUploadResult {
    attachmentId!: string;
    fileName!: string | undefined;
    blobUri!: string | undefined;
    sizeInBytes!: number;
    contentType!: string | undefined;
    subfolderPath!: string | undefined;
    fileNameOnServer!: string | undefined;

    constructor(data?: ISingleFileUploadResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentId = _data["attachmentId"];
            this.fileName = _data["fileName"];
            this.blobUri = _data["blobUri"];
            this.sizeInBytes = _data["sizeInBytes"];
            this.contentType = _data["contentType"];
            this.subfolderPath = _data["subfolderPath"];
            this.fileNameOnServer = _data["fileNameOnServer"];
        }
    }

    static fromJS(data: any): SingleFileUploadResult {
        data = typeof data === 'object' ? data : {};
        let result = new SingleFileUploadResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentId"] = this.attachmentId;
        data["fileName"] = this.fileName;
        data["blobUri"] = this.blobUri;
        data["sizeInBytes"] = this.sizeInBytes;
        data["contentType"] = this.contentType;
        data["subfolderPath"] = this.subfolderPath;
        data["fileNameOnServer"] = this.fileNameOnServer;
        return data;
    }
}

export interface ISingleFileUploadResult {
    attachmentId: string;
    fileName: string | undefined;
    blobUri: string | undefined;
    sizeInBytes: number;
    contentType: string | undefined;
    subfolderPath: string | undefined;
    fileNameOnServer: string | undefined;
}

export class SyncQuoteRequest implements ISyncQuoteRequest {
    opportunityId!: string;
    appointmentId!: string;
    dispositionId!: string;
    subDispositionId!: string;
    email!: string | undefined;
    name!: string | undefined;
    saleAmount!: number;
    contractUrl?: string | undefined;
    notes?: string | undefined;
    tax?: Tax;
    quotedProducts?: Product[] | undefined;
    discounts?: Discount[] | undefined;
    financing?: Financing;

    constructor(data?: ISyncQuoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityId = _data["opportunityId"];
            this.appointmentId = _data["appointmentId"];
            this.dispositionId = _data["dispositionId"];
            this.subDispositionId = _data["subDispositionId"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.saleAmount = _data["saleAmount"];
            this.contractUrl = _data["contractUrl"];
            this.notes = _data["notes"];
            this.tax = _data["tax"] ? Tax.fromJS(_data["tax"]) : undefined as any;
            if (Array.isArray(_data["quotedProducts"])) {
                this.quotedProducts = [] as any;
                for (let item of _data["quotedProducts"])
                    this.quotedProducts!.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["discounts"])) {
                this.discounts = [] as any;
                for (let item of _data["discounts"])
                    this.discounts!.push(Discount.fromJS(item));
            }
            this.financing = _data["financing"] ? Financing.fromJS(_data["financing"]) : undefined as any;
        }
    }

    static fromJS(data: any): SyncQuoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SyncQuoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opportunityId"] = this.opportunityId;
        data["appointmentId"] = this.appointmentId;
        data["dispositionId"] = this.dispositionId;
        data["subDispositionId"] = this.subDispositionId;
        data["email"] = this.email;
        data["name"] = this.name;
        data["saleAmount"] = this.saleAmount;
        data["contractUrl"] = this.contractUrl;
        data["notes"] = this.notes;
        data["tax"] = this.tax ? this.tax.toJSON() : undefined as any;
        if (Array.isArray(this.quotedProducts)) {
            data["quotedProducts"] = [];
            for (let item of this.quotedProducts)
                data["quotedProducts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.discounts)) {
            data["discounts"] = [];
            for (let item of this.discounts)
                data["discounts"].push(item ? item.toJSON() : undefined as any);
        }
        data["financing"] = this.financing ? this.financing.toJSON() : undefined as any;
        return data;
    }
}

export interface ISyncQuoteRequest {
    opportunityId: string;
    appointmentId: string;
    dispositionId: string;
    subDispositionId: string;
    email: string | undefined;
    name: string | undefined;
    saleAmount: number;
    contractUrl?: string | undefined;
    notes?: string | undefined;
    tax?: Tax;
    quotedProducts?: Product[] | undefined;
    discounts?: Discount[] | undefined;
    financing?: Financing;
}

export class SyncServiceQuoteRequest implements ISyncServiceQuoteRequest {
    opportunityId!: string;
    appointmentId!: string;
    dispositionId!: string;
    email!: string | undefined;
    name!: string | undefined;
    saleAmount!: number;
    contractUrl?: string | undefined;
    serviceAttachments?: string[] | undefined;
    notes?: string | undefined;
    tax?: Tax;
    quotedProducts?: Product[] | undefined;
    discounts?: Discount[] | undefined;
    financing?: Financing;

    constructor(data?: ISyncServiceQuoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityId = _data["opportunityId"];
            this.appointmentId = _data["appointmentId"];
            this.dispositionId = _data["dispositionId"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.saleAmount = _data["saleAmount"];
            this.contractUrl = _data["contractUrl"];
            if (Array.isArray(_data["serviceAttachments"])) {
                this.serviceAttachments = [] as any;
                for (let item of _data["serviceAttachments"])
                    this.serviceAttachments!.push(item);
            }
            this.notes = _data["notes"];
            this.tax = _data["tax"] ? Tax.fromJS(_data["tax"]) : undefined as any;
            if (Array.isArray(_data["quotedProducts"])) {
                this.quotedProducts = [] as any;
                for (let item of _data["quotedProducts"])
                    this.quotedProducts!.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["discounts"])) {
                this.discounts = [] as any;
                for (let item of _data["discounts"])
                    this.discounts!.push(Discount.fromJS(item));
            }
            this.financing = _data["financing"] ? Financing.fromJS(_data["financing"]) : undefined as any;
        }
    }

    static fromJS(data: any): SyncServiceQuoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SyncServiceQuoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opportunityId"] = this.opportunityId;
        data["appointmentId"] = this.appointmentId;
        data["dispositionId"] = this.dispositionId;
        data["email"] = this.email;
        data["name"] = this.name;
        data["saleAmount"] = this.saleAmount;
        data["contractUrl"] = this.contractUrl;
        if (Array.isArray(this.serviceAttachments)) {
            data["serviceAttachments"] = [];
            for (let item of this.serviceAttachments)
                data["serviceAttachments"].push(item);
        }
        data["notes"] = this.notes;
        data["tax"] = this.tax ? this.tax.toJSON() : undefined as any;
        if (Array.isArray(this.quotedProducts)) {
            data["quotedProducts"] = [];
            for (let item of this.quotedProducts)
                data["quotedProducts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.discounts)) {
            data["discounts"] = [];
            for (let item of this.discounts)
                data["discounts"].push(item ? item.toJSON() : undefined as any);
        }
        data["financing"] = this.financing ? this.financing.toJSON() : undefined as any;
        return data;
    }
}

export interface ISyncServiceQuoteRequest {
    opportunityId: string;
    appointmentId: string;
    dispositionId: string;
    email: string | undefined;
    name: string | undefined;
    saleAmount: number;
    contractUrl?: string | undefined;
    serviceAttachments?: string[] | undefined;
    notes?: string | undefined;
    tax?: Tax;
    quotedProducts?: Product[] | undefined;
    discounts?: Discount[] | undefined;
    financing?: Financing;
}

export class Tax implements ITax {
    amount?: number;
    rate?: number;
    taxTypeId?: string;

    constructor(data?: ITax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.rate = _data["rate"];
            this.taxTypeId = _data["taxTypeId"];
        }
    }

    static fromJS(data: any): Tax {
        data = typeof data === 'object' ? data : {};
        let result = new Tax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["rate"] = this.rate;
        data["taxTypeId"] = this.taxTypeId;
        return data;
    }
}

export interface ITax {
    amount?: number;
    rate?: number;
    taxTypeId?: string;
}

export class TaxInfo implements ITaxInfo {
    id!: string;
    rate!: number;
    amount!: number;
    taxTypeName!: string | undefined;
    taxTypeId!: string;

    constructor(data?: ITaxInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rate = _data["rate"];
            this.amount = _data["amount"];
            this.taxTypeName = _data["taxTypeName"];
            this.taxTypeId = _data["taxTypeId"];
        }
    }

    static fromJS(data: any): TaxInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TaxInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rate"] = this.rate;
        data["amount"] = this.amount;
        data["taxTypeName"] = this.taxTypeName;
        data["taxTypeId"] = this.taxTypeId;
        return data;
    }
}

export interface ITaxInfo {
    id: string;
    rate: number;
    amount: number;
    taxTypeName: string | undefined;
    taxTypeId: string;
}

export class UnifiedMissingDispositionInfo implements IUnifiedMissingDispositionInfo {
    appointmentId!: string;
    customerName!: string | undefined;
    address!: AddressInfo;
    eventType!: string | undefined;

    constructor(data?: IUnifiedMissingDispositionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.address = new AddressInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentId = _data["appointmentId"];
            this.customerName = _data["customerName"];
            this.address = _data["address"] ? AddressInfo.fromJS(_data["address"]) : new AddressInfo();
            this.eventType = _data["eventType"];
        }
    }

    static fromJS(data: any): UnifiedMissingDispositionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UnifiedMissingDispositionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentId"] = this.appointmentId;
        data["customerName"] = this.customerName;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["eventType"] = this.eventType;
        return data;
    }
}

export interface IUnifiedMissingDispositionInfo {
    appointmentId: string;
    customerName: string | undefined;
    address: AddressInfo;
    eventType: string | undefined;
}

export class UnreviewedSalesListboxInfo implements IUnreviewedSalesListboxInfo {
    needsReview!: PendingSaleInfo[] | undefined;
    serviceNeedsReview!: PendingSaleInfo[] | undefined;
    reviewed!: PendingSaleInfo[] | undefined;

    constructor(data?: IUnreviewedSalesListboxInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["needsReview"])) {
                this.needsReview = [] as any;
                for (let item of _data["needsReview"])
                    this.needsReview!.push(PendingSaleInfo.fromJS(item));
            }
            if (Array.isArray(_data["serviceNeedsReview"])) {
                this.serviceNeedsReview = [] as any;
                for (let item of _data["serviceNeedsReview"])
                    this.serviceNeedsReview!.push(PendingSaleInfo.fromJS(item));
            }
            if (Array.isArray(_data["reviewed"])) {
                this.reviewed = [] as any;
                for (let item of _data["reviewed"])
                    this.reviewed!.push(PendingSaleInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnreviewedSalesListboxInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UnreviewedSalesListboxInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.needsReview)) {
            data["needsReview"] = [];
            for (let item of this.needsReview)
                data["needsReview"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.serviceNeedsReview)) {
            data["serviceNeedsReview"] = [];
            for (let item of this.serviceNeedsReview)
                data["serviceNeedsReview"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reviewed)) {
            data["reviewed"] = [];
            for (let item of this.reviewed)
                data["reviewed"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUnreviewedSalesListboxInfo {
    needsReview: PendingSaleInfo[] | undefined;
    serviceNeedsReview: PendingSaleInfo[] | undefined;
    reviewed: PendingSaleInfo[] | undefined;
}

export class UpdateAttachmentRequestData implements IUpdateAttachmentRequestData {
    attachmentGroupId?: string | undefined;
    description?: string | undefined;

    constructor(data?: IUpdateAttachmentRequestData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachmentGroupId = _data["attachmentGroupId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateAttachmentRequestData {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAttachmentRequestData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentGroupId"] = this.attachmentGroupId;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateAttachmentRequestData {
    attachmentGroupId?: string | undefined;
    description?: string | undefined;
}

export class UpdateAttachmentResult implements IUpdateAttachmentResult {
    success?: boolean;
    attachmentId?: string;
    message?: string | undefined;

    constructor(data?: IUpdateAttachmentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.attachmentId = _data["attachmentId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): UpdateAttachmentResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAttachmentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["attachmentId"] = this.attachmentId;
        data["message"] = this.message;
        return data;
    }
}

export interface IUpdateAttachmentResult {
    success?: boolean;
    attachmentId?: string;
    message?: string | undefined;
}

export class UpdateQuoteRequest implements IUpdateQuoteRequest {
    completedSaleApprovalItems!: SaleApprovalChecklistItems;

    constructor(data?: IUpdateQuoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completedSaleApprovalItems = _data["completedSaleApprovalItems"];
        }
    }

    static fromJS(data: any): UpdateQuoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completedSaleApprovalItems"] = this.completedSaleApprovalItems;
        return data;
    }
}

export interface IUpdateQuoteRequest {
    completedSaleApprovalItems: SaleApprovalChecklistItems;
}

export class UpdateServiceAppointmentDispositionSubmissionDto implements IUpdateServiceAppointmentDispositionSubmissionDto {
    serviceAppointmentId!: string;
    opportunityId!: string;
    dispositionId!: string;
    dispositionDateEntered!: Date;

    constructor(data?: IUpdateServiceAppointmentDispositionSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceAppointmentId = _data["serviceAppointmentId"];
            this.opportunityId = _data["opportunityId"];
            this.dispositionId = _data["dispositionId"];
            this.dispositionDateEntered = _data["dispositionDateEntered"] ? new Date(_data["dispositionDateEntered"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateServiceAppointmentDispositionSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceAppointmentDispositionSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceAppointmentId"] = this.serviceAppointmentId;
        data["opportunityId"] = this.opportunityId;
        data["dispositionId"] = this.dispositionId;
        data["dispositionDateEntered"] = this.dispositionDateEntered ? this.dispositionDateEntered.toISOString() : undefined as any;
        return data;
    }
}

export interface IUpdateServiceAppointmentDispositionSubmissionDto {
    serviceAppointmentId: string;
    opportunityId: string;
    dispositionId: string;
    dispositionDateEntered: Date;
}

export class UploadRemoteFileRequest implements IUploadRemoteFileRequest {
    opportunityId?: string;
    appointmentId?: string;
    remoteFileUrl?: string | undefined;

    constructor(data?: IUploadRemoteFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.opportunityId = _data["opportunityId"];
            this.appointmentId = _data["appointmentId"];
            this.remoteFileUrl = _data["remoteFileUrl"];
        }
    }

    static fromJS(data: any): UploadRemoteFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UploadRemoteFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["opportunityId"] = this.opportunityId;
        data["appointmentId"] = this.appointmentId;
        data["remoteFileUrl"] = this.remoteFileUrl;
        return data;
    }
}

export interface IUploadRemoteFileRequest {
    opportunityId?: string;
    appointmentId?: string;
    remoteFileUrl?: string | undefined;
}

export class UserBranchInfo implements IUserBranchInfo {
    id!: string;
    brandId!: string;
    legacyDealerId?: number | undefined;
    legacyZoneId?: number | undefined;

    constructor(data?: IUserBranchInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.brandId = _data["brandId"];
            this.legacyDealerId = _data["legacyDealerId"];
            this.legacyZoneId = _data["legacyZoneId"];
        }
    }

    static fromJS(data: any): UserBranchInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserBranchInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["brandId"] = this.brandId;
        data["legacyDealerId"] = this.legacyDealerId;
        data["legacyZoneId"] = this.legacyZoneId;
        return data;
    }
}

export interface IUserBranchInfo {
    id: string;
    brandId: string;
    legacyDealerId?: number | undefined;
    legacyZoneId?: number | undefined;
}

export class UserBranchesInfo implements IUserBranchesInfo {
    userId?: string | undefined;
    branchIds!: string[] | undefined;
    brandIds!: string[] | undefined;
    branches!: UserBranchInfo[] | undefined;

    constructor(data?: IUserBranchesInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
            if (Array.isArray(_data["brandIds"])) {
                this.brandIds = [] as any;
                for (let item of _data["brandIds"])
                    this.brandIds!.push(item);
            }
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(UserBranchInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserBranchesInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserBranchesInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        if (Array.isArray(this.brandIds)) {
            data["brandIds"] = [];
            for (let item of this.brandIds)
                data["brandIds"].push(item);
        }
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserBranchesInfo {
    userId?: string | undefined;
    branchIds: string[] | undefined;
    brandIds: string[] | undefined;
    branches: UserBranchInfo[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}